import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={1310}
        height={962}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 1310 962`}
    >
        <path
            d="M1136.28 0 0 656.029l169.5 293.583 1136.28-656.029L1136.28 0Z"
            fill="url(#a)"
        />
        <path
            d="M1221.63 149.998 88 810.592l88.164 151.296L1309.79 301.294l-88.16-151.296Z"
            fill="#191822"
        />
        <path
            d="m665.3 531.967-.007 2.7-1.483-2.617.008-2.7 1.482 2.617Z"
            fill="#1B2127"
        />
        <path
            d="m668.332 530.194-3.033 1.773-1.483-2.618 4.516.845Z"
            fill="#35404D"
        />
        <path
            d="m668.343 530.196 7.681 4.436-3.044 1.768-7.68-4.433 3.043-1.771Z"
            fill="#FBAB20"
        />
        <path
            d="m672.981 536.399-.007 2.7-7.682-4.432.007-2.7 7.682 4.432Z"
            fill="#8D5700"
        />
        <path
            d="m676.736 534.559-3.876 2.253.12-.413 3.044-1.768.712-.072Z"
            fill="#35404D"
        />
        <path
            d="m686.912 544.924-.008 2.7-14.051-8.113.007-2.7 14.052 8.113Z"
            fill="#B73D34"
        />
        <path
            d="m672.86 536.812 3.876-2.253 14.055 8.113-3.877 2.252-14.054-8.112Z"
            fill="#EB5A49"
        />
        <path
            d="m691.791 543.25-3.876 2.253-.806.468-.081.047a1.01 1.01 0 0 1-.916 0l-.857-.5-4.149-2.4-.459-.265c-.018-.013-.038-.024-.057-.036a2.24 2.24 0 0 0-.89-.205 2.24 2.24 0 0 1-.792-.154.315.315 0 0 1-.165-.225c-.087-.492 1.24-.558 2.113-.277.357.122.702.277 1.029.464l.212.122 4.149 2.395.317.184.351-.205 3.877-2.252 1 .586Z"
            fill="#35404D"
        />
        <path
            d="m687.106 545.967-.081.047a.75.75 0 0 1-.2.078c-.025.006-.05.007-.075.011a.98.98 0 0 1-.154.017h-.091a.955.955 0 0 1-.394-.104l-.857-.5-4.149-2.4-.459-.265c-.018-.013-.038-.024-.057-.036a.988.988 0 0 0-.131-.063l-.028-.007a1.886 1.886 0 0 0-.314-.083l-.082-.012a5.28 5.28 0 0 0-.335-.04l-.334-.035c-.023 0-.046 0-.068-.009a1.52 1.52 0 0 1-.282-.066.72.72 0 0 1-.108-.044.315.315 0 0 1-.165-.225.353.353 0 0 1 0-.046l-.009 2.7.005.045a.318.318 0 0 0 .165.225.817.817 0 0 0 .079.038l.031.007c.091.031.185.053.279.066l.074.008c.105.014.215.024.33.035.115.011.231.024.344.042l.067.009a1.84 1.84 0 0 1 .479.154l.057.037.457.264 4.15 2.4.856.5a.515.515 0 0 0 .168.063.955.955 0 0 0 .318.04.864.864 0 0 0 .153-.017c.026 0 .052 0 .075-.011a.747.747 0 0 0 .2-.077l.08-.048.806-.468.008-2.7-.808.47Z"
            fill="#1C2128"
        />
        <path
            d="m693.736 544.374-.007 2.7-.417.241.008-2.7.416-.241ZM690.276 546.385l-.007 2.7-.417.243.007-2.7.417-.243Z"
            fill="#731F00"
        />
        <path
            d="m689.858 546.626-.007 2.7-1.946-1.124.007-2.7 1.946 1.124Z"
            fill="#B73D34"
        />
        <path
            d="m691.792 543.25 1.946 1.124-.416.241-3.044 1.769-.417.241-1.946-1.123 3.877-2.252Z"
            fill="#EB5A49"
        />
        <path
            d="m694.108 545.067-.007 2.7-3.044 1.768.007-2.7 3.044-1.768Z"
            fill="#1E242B"
        />
        <path
            d="m691.064 546.84-.007 2.7-.789-.456.007-2.7.789.456Z"
            fill="#1D232A"
        />
        <path
            d="m694.107 545.067-3.044 1.769-.789-.455 3.044-1.769.789.455Z"
            fill="#35404D"
        />
        <path d="m704.091 503.113-9.627 5.594-9.689-5.594h19.316Z" fill="#D7E7F7" />
        <path
            d="m708.241 507.985-29.807 17.322-3.262-1.884 29.806-17.321 3.263 1.883ZM714.473 511.584l-29.806 17.322-3.266-1.886 29.806-17.321 3.266 1.885Z"
            fill="#F8F9FC"
        />
        <path
            d="m714.473 511.584-16.576 9.621-3.266-1.886 16.576-9.62 3.266 1.885ZM720.556 515.095l-29.806 17.323-3.259-1.883 29.8-17.323 3.265 1.883ZM718.533 524.116l-21.013 12.21-3.266-1.885 21.013-12.211 3.266 1.886Z"
            fill="#35404D"
        />
        <path
            d="m704.091 503.113-9.627 5.594-9.689-5.594-25.162 14.623 43.21 24.947 34.788-20.216-33.52-19.354Zm-28.919 20.311 29.806-17.322 3.263 1.883-29.807 17.322-3.262-1.883Zm6.229 3.6 29.807-17.321 3.265 1.884-29.806 17.319-3.266-1.882Zm6.086 3.515 29.804-17.327 3.262 1.883-29.803 17.322-3.263-1.878Zm10.033 5.791-3.265-1.884 21.012-12.212 3.266 1.886-21.013 12.21Z"
            fill="#F8F9FC"
        />
        <path
            d="m702.822 542.683-43.21-24.948v1.33l43.21 24.948 34.788-20.216v-1.331l-34.788 20.217Z"
            fill="#D7E7F7"
        />
        <path
            d="M682.542 523.424c.122.068.233.156.328.259a.905.905 0 0 1 .122.184.611.611 0 0 1 .066.373.956.956 0 0 1-.513.644 2.043 2.043 0 0 1-.454.194l-.1.026a2.979 2.979 0 0 1-1.573-.045 2.088 2.088 0 0 1-.4-.174 1.004 1.004 0 0 1-.1-.064 1.226 1.226 0 0 1-.231-.2c-.4-.447-.168-.989.5-1.285.09-.039.182-.073.276-.1.098-.029.199-.052.3-.07a2.774 2.774 0 0 1 1.779.258Z"
            fill="#FFBF00"
        />
        <path
            d="M687.873 523.422a.69.69 0 0 0 .139.367l-4.953.449a.612.612 0 0 0-.068-.371l4.882-.445Z"
            fill="#02567D"
        />
        <path
            d="M690.915 522.662c.125.07.237.159.333.265.444.507.1 1.13-.777 1.385-.282.081-.575.12-.869.113a3.034 3.034 0 0 1-.636-.08 2.152 2.152 0 0 1-.567-.22 1.288 1.288 0 0 1-.387-.336.69.69 0 0 1-.139-.367c-.022-.388.335-.766.973-.953a2.99 2.99 0 0 1 1.423-.046c.226.046.444.126.646.239Z"
            fill="#E54332"
        />
        <path
            d="m688.218 511.306.186.359-3.9.688a.628.628 0 0 0-.069-.383l3.783-.664Z"
            fill="#02567D"
        />
        <path
            d="M683.98 511.534c.124.07.236.159.332.265a.835.835 0 0 1 .117.171.614.614 0 0 1 .069.383c-.051.344-.4.666-.97.835a2.775 2.775 0 0 1-.325.073 3.041 3.041 0 0 1-.646.033 2.509 2.509 0 0 1-1.094-.3 1.305 1.305 0 0 1-.329-.263c-.451-.512-.106-1.134.769-1.39a2.825 2.825 0 0 1 2.077.193Z"
            fill="#E54332"
        />
        <path
            d="m683.203 513.261.55 2.032c-.215-.007-.43.01-.641.049l-.555-2.048c.216.012.432.001.646-.033Z"
            fill="#02567D"
        />
        <path
            d="M684.92 515.593c.124.069.236.158.331.264a.661.661 0 0 1 .058.875 1.201 1.201 0 0 1-.361.316 2.049 2.049 0 0 1-.467.2 2.901 2.901 0 0 1-1.891-.1 1.677 1.677 0 0 1-.185-.092 1.428 1.428 0 0 1-.332-.265c-.444-.508-.1-1.13.783-1.39a2.992 2.992 0 0 1 .897-.109c.407.006.808.109 1.167.301ZM691.905 518.078a.99.99 0 0 1 .247.195c.332.374.07.84-.581 1.027a2.212 2.212 0 0 1-1.121.022 1.6 1.6 0 0 1-.413-.162.995.995 0 0 1-.247-.2.487.487 0 0 1-.109-.516.736.736 0 0 1 .294-.335c.123-.079.258-.138.4-.176a2.069 2.069 0 0 1 1.53.145Z"
            fill="#FFBF00"
        />
        <path
            d="m685.308 516.732 4.666 1.381a.741.741 0 0 0-.294.335l-4.733-1.4c.141-.08.264-.187.361-.316ZM690.27 522.423a2.99 2.99 0 0 0-.64-.065l.82-3.036c.21.051.427.071.644.059l-.824 3.042Z"
            fill="#02567D"
        />
        <path
            d="M679.415 518.739c.072.042.139.086.2.132.112.08.214.171.305.273.639.721.226 1.593-.906 2.027-.09.035-.184.067-.282.1-.098.033-.2.054-.3.076a4.273 4.273 0 0 1-2.871-.365 2.035 2.035 0 0 1-.505-.4 1.133 1.133 0 0 1-.3-.611.94.94 0 0 1 .032-.373 1.987 1.987 0 0 1 1.451-1.146 4.44 4.44 0 0 1 2.906.162c.101.034.188.078.27.125Z"
            fill="#134663"
        />
        <path
            d="M682.152 516.873a1.466 1.466 0 0 0 .437.276l-2.97 1.722a4.922 4.922 0 0 0-.2-.132 3.008 3.008 0 0 0-.26-.132l2.993-1.734ZM680.467 523.232a2.514 2.514 0 0 0-.275.1l-.828-.939-.926-1.051c.1-.022.199-.047.299-.076.1-.029.193-.06.283-.1l1.752 1.991a2.767 2.767 0 0 0-.305.075Z"
            fill="#02567D"
        />
        <path
            d="M688.833 511.081a.849.849 0 0 1 .22.176c.3.332.07.741-.509.909a1.83 1.83 0 0 1-1.351-.122.853.853 0 0 1-.22-.176c-.3-.332-.07-.741.509-.909a1.83 1.83 0 0 1 1.351.122Z"
            fill="#E54332"
        />
        <path d="M902.86 332.76 527.053 551.14Z" fill="#35404D" />
        <path d="M902.86 332.76 527.053 551.14" stroke="#DEDDE2" />
        <path d="m819.466 447.228-33.016 19.185Z" fill="#35404D" />
        <path d="m819.466 447.228-33.016 19.185" stroke="#fff" />
        <path d="M622.556 428.785 589.54 447.97Z" fill="#35404D" />
        <path d="M622.556 428.785 589.54 447.97" stroke="#fff" />
        <path
            d="m324.702 590.301 124.652-71.881c6.721-3.876 17.619-3.876 24.341 0l124.654 71.877c6.721 3.876 6.721 10.16 0 14.036l-124.656 71.885c-6.722 3.876-17.62 3.876-24.342 0l-124.649-71.883c-6.721-3.875-6.721-10.159 0-14.034Z"
            fill="#282739"
        />
        <path
            d="M569.504 570.235h-67.255l-40.87 53.6h108.125l46.749-26.8-46.749-26.8ZM455.869 553.487h-39.845l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.573h2.972l10.737 6.155h39.845l15.263-8.75-15.26-8.753Z"
            fill="#101015"
        />
        <path
            d="M433.233 566.466h-39.848l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.574h2.974l10.738 6.151h39.845l15.263-8.75-15.26-8.75Z"
            fill="#101015"
        />
        <path
            d="M410.522 579.429h-39.845l-12.661 7.258-1.025-1.082-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.846l15.263-8.75-15.263-8.754Z"
            fill="#101015"
        />
        <path
            d="M436.59 594.673h-39.845l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.845l15.263-8.75-15.262-8.753Z"
            fill="#101015"
        />
        <path
            d="M322.661 593.071c-1.503 1.503-2.18 3.189-1.958 4.873.27 2.046 1.868 4.008 4.499 5.526l124.651 71.88c3.102 1.788 7.246 2.773 11.671 2.773 4.425 0 8.57-.985 11.671-2.773l124.651-71.88c.997-.575 1.852-1.216 2.541-1.905 1.504-1.504 2.181-3.189 1.958-4.874-.269-2.045-1.867-4.007-4.499-5.525l-124.651-71.88c-3.101-1.788-7.246-2.773-11.671-2.773-4.425 0-8.569.985-11.671 2.773l-124.651 71.88c-.997.575-1.852 1.216-2.541 1.905Zm-.707-.707c.738-.738 1.654-1.433 2.749-2.064l124.651-71.88c6.721-3.876 17.619-3.876 24.341 0l124.651 71.88c6.721 3.876 6.721 10.16 0 14.036l-124.651 71.88c-6.722 3.876-17.62 3.876-24.341 0l-124.651-71.88c-5.627-3.245-6.544-8.178-2.749-11.972Z"
            fill="#DEDDE2"
        />
        <path
            d="M501.241 527.542h-39.845l-12.661 7.258-1.025-1.082-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.845l15.263-8.75-15.262-8.754Z"
            fill="#93A865"
        />
        <path
            d="M452.132 536.31v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M443.153 536.31v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m447.642 525.951-4.489 2.574 4.489 2.573 4.489-2.573-4.489-2.574Z"
            fill="#F2F2F2"
        />
        <path
            d="M462.905 522.866V511.76l-15.263 8.75v11.105l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M432.379 522.866V511.76l15.263 8.75v11.105l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m447.642 503.01-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M462.905 508.334v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M432.379 508.334v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m447.642 488.479-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M462.905 493.803v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M432.379 493.803v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m447.642 473.947-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M406.804 562.254v-7.788l-4.489 2.573v7.785l4.489-2.57Z"
            fill="#A67C52"
        />
        <path
            d="M397.826 562.254v-7.788l4.489 2.573v7.785l-4.489-2.57Z"
            fill="#C69C6D"
        />
        <path
            d="m402.315 551.895-4.489 2.571 4.489 2.573 4.489-2.573-4.489-2.571Z"
            fill="#F2F2F2"
        />
        <path
            d="M417.577 548.809v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M387.052 548.809v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m402.315 528.953-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M417.577 534.277v-11.105l-15.263 8.75v11.106l15.263-8.751Z"
            fill="#75934C"
        />
        <path
            d="M387.052 534.277v-11.105l15.263 8.75v11.106l-15.263-8.751Z"
            fill="#AAD86F"
        />
        <path
            d="m402.315 514.422-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M417.577 519.747v-11.106l-15.263 8.75v11.105l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M387.052 519.747v-11.106l15.263 8.75v11.105l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m402.315 499.891-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M384.094 575.218v-7.785l-4.49 2.573v7.785l4.49-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M375.114 575.218v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m379.604 564.859-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M394.867 561.773v-11.107l-15.263 8.75v11.106l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M364.341 561.773v-11.107l15.263 8.75v11.106l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m379.604 541.917-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M394.867 547.241v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M364.341 547.241v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m379.604 527.386-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M394.867 532.71v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M364.341 532.71v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m379.604 512.855-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M361.455 588.2v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M352.476 588.2v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m356.966 577.841-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M372.229 574.755V563.65l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M341.702 574.755V563.65l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m356.966 554.9-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M372.229 560.224v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M341.702 560.224v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m356.966 540.366-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M372.229 545.693v-11.105l-15.263 8.75v11.106l15.263-8.751Z"
            fill="#75934C"
        />
        <path
            d="M341.702 545.693v-11.105l15.263 8.75v11.106l-15.263-8.751Z"
            fill="#AAD86F"
        />
        <path
            d="m356.966 525.838-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M387.523 603.444v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M378.544 603.444v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m383.033 593.085-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M398.295 589.999v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M367.77 589.999v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m383.033 570.143-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M398.295 575.466v-11.1l-15.263 8.75v11.105l15.263-8.755Z"
            fill="#75934C"
        />
        <path
            d="M367.77 575.466v-11.1l15.263 8.75v11.105l-15.263-8.755Z"
            fill="#AAD86F"
        />
        <path
            d="m383.033 555.612-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M398.295 560.936v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M367.77 560.936v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m383.033 541.081-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M498.16 559.675v-7.773l-4.482 2.569v7.773l4.482-2.569Z"
            fill="#A67C52"
        />
        <path
            d="M489.196 559.675v-7.773l4.482 2.569v7.773l-4.482-2.569Z"
            fill="#C69C6D"
        />
        <path
            d="m493.678 549.333-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M508.917 546.252v-11.086l-15.238 8.735v11.087l15.238-8.736Z"
            fill="#75934C"
        />
        <path
            d="M478.439 546.252v-11.086l15.238 8.735v11.087l-15.238-8.736Z"
            fill="#AAD86F"
        />
        <path
            d="m493.678 526.429-15.238 8.736 15.238 8.735 15.238-8.735-15.238-8.736Z"
            fill="#75934C"
        />
        <path
            d="M508.917 531.744v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M478.439 531.744v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m493.678 511.922-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M508.917 517.237V506.15l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M478.439 517.237V506.15l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m493.678 497.414-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M524.185 574.893v-7.772l-4.482 2.569v7.776l4.482-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M515.222 574.893v-7.772l4.482 2.569v7.776l-4.482-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m519.704 564.551-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M534.942 561.466v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M504.466 561.466v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m519.704 541.648-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M534.942 546.966v-11.09l-15.238 8.736v11.087l15.238-8.733Z"
            fill="#75934C"
        />
        <path
            d="M504.466 546.966v-11.09l15.238 8.736v11.087l-15.238-8.733Z"
            fill="#AAD86F"
        />
        <path
            d="m519.704 527.141-15.238 8.735 15.238 8.736 15.238-8.736-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M534.942 532.456v-11.09l-15.238 8.735v11.087l15.238-8.732Z"
            fill="#75934C"
        />
        <path
            d="M504.466 532.456v-11.09l15.238 8.735v11.087l-15.238-8.732Z"
            fill="#AAD86F"
        />
        <path
            d="m519.704 512.633-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M547.757 586.333v-7.773l-4.482 2.569v7.772l4.482-2.568Z"
            fill="#A67C52"
        />
        <path
            d="M538.794 586.333v-7.773l4.482 2.569v7.772l-4.482-2.568Z"
            fill="#C69C6D"
        />
        <path
            d="m543.275 575.991-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M558.513 572.91v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M528.037 572.91v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m543.275 553.087-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M558.513 558.403v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M528.037 558.403v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m543.275 538.58-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M558.513 543.895v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M528.037 543.895v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m543.275 524.073-15.238 8.736 15.238 8.735 15.238-8.735-15.238-8.736Z"
            fill="#C7F08F"
        />
        <path
            d="M573.786 601.552v-7.773l-4.482 2.569v7.773l4.482-2.569Z"
            fill="#A67C52"
        />
        <path
            d="M564.819 601.552v-7.773l4.482 2.569v7.773l-4.482-2.569Z"
            fill="#C69C6D"
        />
        <path
            d="m569.301 591.21-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M584.54 588.129v-11.087l-15.238 8.736v11.088l15.238-8.737Z"
            fill="#75934C"
        />
        <path
            d="M554.062 588.129v-11.087l15.239 8.736v11.088l-15.239-8.737Z"
            fill="#AAD86F"
        />
        <path
            d="m569.302 568.306-15.239 8.735 15.239 8.736 15.238-8.736-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M584.54 573.621v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M554.062 573.621v-11.087l15.239 8.735v11.087l-15.239-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m569.302 553.799-15.239 8.735 15.239 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M584.54 559.114v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M554.062 559.114v-11.087l15.239 8.735v11.087l-15.239-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m569.302 539.291-15.239 8.735 15.239 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M414.63 597.096v-54.184l46.749 26.8v54.183l-46.749-26.799Z"
            fill="#DEDDE2"
        />
        <path
            d="M508.127 597.096v-54.184l-46.749 26.8v54.183l46.749-26.799Z"
            fill="#ADABB9"
        />
        <path
            d="m461.378 516.113-46.749 26.8 46.749 26.8 46.749-26.8-46.749-26.8Z"
            fill="#E3DAD7"
        />
        <path
            d="M414.63 543.092v-54.183l46.749 26.8v54.184l-46.749-26.801Z"
            fill="#DEDDE2"
        />
        <path
            d="M508.127 543.092v-54.183l-46.749 26.8v54.184l46.749-26.801Z"
            fill="#ADABB9"
        />
        <path
            d="m461.378 462.11-46.749 26.8 46.749 26.8 46.749-26.8-46.749-26.8Z"
            fill="#D7D6DD"
        />
        <path
            d="M480.391 527.249v-9.344l11.362-6.56v9.344l8.958-5.172v11.191l-8.958 5.172v9.43l-11.362 6.56v-9.43l-8.959 5.173v-11.191l8.959-5.173ZM443.157 527.249v-9.344l-11.362-6.56v9.344l-8.958-5.172v11.191l8.958 5.172v9.43l11.362 6.56v-9.43l8.959 5.173v-11.191l-8.959-5.173Z"
            fill="#4361EE"
        />
        <path
            d="m454.674 566.841-33.457-19.04.014 44.265 33.442 19.032.001-44.257Z"
            fill="#ADABB9"
        />
        <path
            d="m422.751 591.237 31.923 18.159v-42.555l-31.935-18.166.012 42.562Z"
            fill="#FAF8F8"
        />
        <path
            d="m468.441 566.841 33.457-19.04-.013 44.265-33.443 19.032-.001-44.257Z"
            fill="#888595"
        />
        <path
            d="m500.364 591.237-31.923 18.159v-42.555l31.935-18.166-.012 42.562Z"
            fill="#E9E5F2"
        />
        <path
            d="m461.378 462.11-46.748 26.8 46.748 26.8 46.749-26.8-46.749-26.8Zm-36.509 26.8 36.509-20.93 36.51 20.93-36.51 20.929-36.509-20.929Z"
            fill="#F4EFED"
        />
        <path
            d="m562.189 478.739-19.181-11.145-.007-2.455 19.177 11.144.011 2.456Z"
            fill="#003959"
        />
        <path
            d="m562.178 476.283-19.177-11.144 40.732-23.516 19.177 11.144-40.732 23.516Z"
            fill="#02567D"
        />
        <path
            d="m577.989 469.61-15.8 9.129-.007-2.455 40.732-23.517.007 2.455-24.932 14.388Z"
            fill="#134663"
        />
        <path
            d="M585.189 428.119a7.975 7.975 0 0 1 7.241.073 2.303 2.303 0 0 1 1.359 2.418l4.39 2.718 3.455-1.994-13.42-7.813-6.525 3.768 2.612 1.509c.262-.268.561-.497.888-.679Z"
            fill="#02567D"
        />
        <path
            d="M584.899 410.878v39.158a3.833 3.833 0 0 0 7.664 0v-39.158h-7.664Z"
            fill="#ADE9F4"
        />
        <path
            d="M585.56 424.843v25.193a3.18 3.18 0 0 0 .909 2.28 3.168 3.168 0 0 0 2.264.949 3.175 3.175 0 0 0 3.172-3.229v-25.193h-6.345Z"
            fill="#E54332"
        />
        <path
            d="M591.02 423.567c1.213.73 1.172 1.893-.093 2.6a4.935 4.935 0 0 1-4.485-.045c-1.212-.73-1.171-1.893.093-2.6a4.938 4.938 0 0 1 4.485.045Z"
            fill="#E56759"
        />
        <path
            d="M584.111 411.049v-.693a2.263 2.263 0 0 0 1.286 1.846 7.191 7.191 0 0 0 6.535.066c.39-.165.728-.432.979-.773a2.35 2.35 0 0 0 .443-1.166v.693a2.337 2.337 0 0 1-1.422 1.94 7.206 7.206 0 0 1-6.535-.067 2.262 2.262 0 0 1-1.286-1.846Z"
            fill="#7FE2F4"
        />
        <path
            d="M592.067 408.483c1.767 1.063 1.707 2.758-.135 3.785a7.212 7.212 0 0 1-3.275.751 7.184 7.184 0 0 1-3.259-.817c-1.768-1.064-1.707-2.759.135-3.786a7.192 7.192 0 0 1 6.534.067Z"
            fill="#ADE9F4"
        />
        <path
            d="M588.718 412.359a5.945 5.945 0 0 1-2.98-.723 1.638 1.638 0 0 1-.967-1.3 1.77 1.77 0 0 1 1.084-1.343 6.05 6.05 0 0 1 2.892-.668 5.971 5.971 0 0 1 2.98.723 1.637 1.637 0 0 1 .967 1.3 1.785 1.785 0 0 1-1.083 1.343 6.048 6.048 0 0 1-2.893.668Z"
            fill="#7FE2F4"
        />
        <path
            d="m596.281 453.455-2.426-1.41v-.516l2.426 1.41v.516Z"
            fill="#002F4A"
        />
        <path
            d="m596.28 452.939-2.426-1.41 2.369-1.353 2.426 1.41-2.369 1.353Z"
            fill="#0370A3"
        />
        <path
            d="M598.647 451.586v.516l-2.369 1.354v-.515l2.369-1.355Z"
            fill="#004266"
        />
        <path
            d="m595.398 433.728.029 17.927.939.546-.03-18.473h-.938Z"
            fill="#002F4A"
        />
        <path
            d="m596.336 433.728.03 18.473.825-.476-.029-18-.826.003Z"
            fill="#003959"
        />
        <path
            d="M593.789 430.61a2.813 2.813 0 0 1-1.513 1.776 7.978 7.978 0 0 1-7.241-.073c-1.608-.968-1.828-2.4-.733-3.516l-2.613-1.508-9.788 5.651 2.6 1.5c.27-.289.583-.534.927-.726a7.975 7.975 0 0 1 7.241.074c1.364.821 1.722 1.978 1.138 2.991l4.08 2.495 10.295-5.944-4.393-2.72Z"
            fill="#02567D"
        />
        <path
            d="M575.14 416.664v39.158a3.83 3.83 0 0 0 6.541 2.71 3.831 3.831 0 0 0 1.123-2.71v-39.158h-7.664Z"
            fill="#ADE9F4"
        />
        <path
            d="M575.8 430.63v25.192a3.172 3.172 0 1 0 6.344 0V430.63H575.8Z"
            fill="#E54332"
        />
        <path
            d="M581.261 429.353c1.213.73 1.172 1.893-.093 2.6a4.934 4.934 0 0 1-4.485-.045c-1.212-.73-1.171-1.893.093-2.6a4.938 4.938 0 0 1 4.485.045Z"
            fill="#E56759"
        />
        <path
            d="M574.352 416.836v-.694a2.265 2.265 0 0 0 1.286 1.846 7.2 7.2 0 0 0 6.535.066 2.347 2.347 0 0 0 1.416-1.944v.694a2.351 2.351 0 0 1-1.422 1.939 7.2 7.2 0 0 1-6.535-.066 2.256 2.256 0 0 1-1.28-1.841Z"
            fill="#7FE2F4"
        />
        <path
            d="M582.307 414.269c1.767 1.063 1.707 2.758-.135 3.785a7.196 7.196 0 0 1-6.535-.066c-1.767-1.064-1.706-2.758.136-3.785a7.206 7.206 0 0 1 6.534.066Z"
            fill="#ADE9F4"
        />
        <path
            d="M578.958 418.145a5.945 5.945 0 0 1-2.98-.723 1.64 1.64 0 0 1-.967-1.3 1.778 1.778 0 0 1 1.083-1.343 6.051 6.051 0 0 1 2.895-.669 5.965 5.965 0 0 1 2.981.723 1.648 1.648 0 0 1 .967 1.3 1.78 1.78 0 0 1-1.083 1.343c-.895.46-1.89.69-2.896.669Z"
            fill="#7FE2F4"
        />
        <path
            d="M583.806 436.778c-.312.51-.757.925-1.288 1.2a7.976 7.976 0 0 1-7.241-.073c-1.586-.954-1.82-2.362-.777-3.469l-2.6-1.5-9.032 5.214 2.427 1.4a4.41 4.41 0 0 1 .464-.316 7.973 7.973 0 0 1 7.241.073c1.279.769 1.678 1.835 1.244 2.8l4.261 2.575 9.377-5.414-4.076-2.49Z"
            fill="#02567D"
        />
        <path
            d="M565.477 422.12v39.158c0 .503.099 1.002.291 1.467a3.818 3.818 0 0 0 2.074 2.073 3.825 3.825 0 0 0 2.933 0 3.818 3.818 0 0 0 2.074-2.073c.192-.465.292-.964.292-1.467V422.12h-7.664Z"
            fill="#ADE9F4"
        />
        <path
            d="M566.137 436.086v25.192a3.172 3.172 0 1 0 6.344 0v-25.192h-6.344Z"
            fill="#E54332"
        />
        <path
            d="M571.598 434.81c1.213.73 1.171 1.893-.093 2.6a4.938 4.938 0 0 1-4.485-.045c-1.213-.73-1.171-1.893.093-2.6a4.935 4.935 0 0 1 4.485.045Z"
            fill="#E56759"
        />
        <path
            d="M564.689 422.291v-.693a2.259 2.259 0 0 0 1.287 1.846 7.204 7.204 0 0 0 6.534.066 2.348 2.348 0 0 0 1.422-1.939v.693a2.337 2.337 0 0 1-1.422 1.94 7.192 7.192 0 0 1-6.534-.067 2.272 2.272 0 0 1-1.287-1.846Z"
            fill="#7FE2F4"
        />
        <path
            d="M572.644 419.725c1.767 1.063 1.706 2.758-.136 3.785a7.206 7.206 0 0 1-6.534-.066c-1.767-1.064-1.706-2.758.135-3.786a7.204 7.204 0 0 1 6.535.067Z"
            fill="#ADE9F4"
        />
        <path
            d="M569.289 423.601a5.956 5.956 0 0 1-2.98-.723 1.638 1.638 0 0 1-.967-1.3 1.77 1.77 0 0 1 1.084-1.343 6.039 6.039 0 0 1 2.892-.668 5.975 5.975 0 0 1 2.981.723 1.648 1.648 0 0 1 .967 1.3 1.781 1.781 0 0 1-1.077 1.343 6.038 6.038 0 0 1-2.9.668Z"
            fill="#7FE2F4"
        />
        <path
            d="M555.889 444.904a7.971 7.971 0 0 1 7.241.074c1.347.811 1.712 1.949 1.159 2.954l4.189 2.545 3.115-1.8 6.913-3.992-4.258-2.575a3.123 3.123 0 0 1-1.394 1.394 7.972 7.972 0 0 1-7.241-.073c-1.789-1.077-1.867-2.731-.314-3.878l-2.427-1.4-4.752 2.744-5.568 3.213 2.489 1.437a3.91 3.91 0 0 1 .848-.643Z"
            fill="#02567D"
        />
        <path
            d="M555.462 428.028v39.158c0 1.016.404 1.991 1.122 2.71a3.836 3.836 0 0 0 5.42 0 3.836 3.836 0 0 0 1.122-2.71v-39.158h-7.664Z"
            fill="#ADE9F4"
        />
        <path
            d="M556.123 441.993v25.192a3.167 3.167 0 0 0 .909 2.28 3.16 3.16 0 0 0 2.263.949 3.17 3.17 0 0 0 3.173-3.229v-25.192h-6.345Z"
            fill="#E54332"
        />
        <path
            d="M561.584 440.717c1.213.73 1.172 1.893-.092 2.6a4.94 4.94 0 0 1-4.485-.046c-1.213-.729-1.172-1.893.092-2.6a4.947 4.947 0 0 1 4.485.046Z"
            fill="#E56759"
        />
        <path
            d="M554.674 428.199v-.694a2.266 2.266 0 0 0 1.287 1.846 7.198 7.198 0 0 0 6.534.067 2.35 2.35 0 0 0 1.422-1.94v.694c-.04.422-.193.824-.444 1.165a2.33 2.33 0 0 1-.978.773 7.196 7.196 0 0 1-6.534-.066 2.254 2.254 0 0 1-1.287-1.845Z"
            fill="#7FE2F4"
        />
        <path
            d="M562.629 425.632c1.768 1.064 1.707 2.759-.135 3.786a7.206 7.206 0 0 1-6.534-.067c-1.768-1.063-1.707-2.758.135-3.785a7.206 7.206 0 0 1 6.534.066Z"
            fill="#ADE9F4"
        />
        <path
            d="M559.28 429.51a5.958 5.958 0 0 1-2.98-.723 1.648 1.648 0 0 1-.967-1.3 1.78 1.78 0 0 1 1.084-1.344 6.055 6.055 0 0 1 2.892-.667 5.958 5.958 0 0 1 2.98.723 1.64 1.64 0 0 1 .967 1.3 1.78 1.78 0 0 1-1.083 1.343 6.045 6.045 0 0 1-2.893.668ZM588.718 412.359a5.95 5.95 0 0 1-2.98-.723 1.644 1.644 0 0 1-.967-1.3 1.782 1.782 0 0 1 1.084-1.343 6.056 6.056 0 0 1 2.892-.668 5.966 5.966 0 0 1 2.98.723 1.633 1.633 0 0 1 .967 1.3 1.773 1.773 0 0 1-1.083 1.343 6.043 6.043 0 0 1-2.893.668ZM578.989 414.11a5.961 5.961 0 0 1 2.98.723 1.648 1.648 0 0 1 .967 1.3 1.785 1.785 0 0 1-1.084 1.344 6.055 6.055 0 0 1-2.892.667 5.945 5.945 0 0 1-2.98-.723 1.64 1.64 0 0 1-.967-1.3c.051-.298.177-.577.367-.812.189-.236.436-.419.716-.532a6.056 6.056 0 0 1 2.893-.667ZM569.289 423.601a5.956 5.956 0 0 1-2.98-.723 1.638 1.638 0 0 1-.967-1.3 1.77 1.77 0 0 1 1.084-1.343 6.039 6.039 0 0 1 2.892-.668 5.975 5.975 0 0 1 2.981.723 1.648 1.648 0 0 1 .967 1.3 1.781 1.781 0 0 1-1.077 1.343 6.038 6.038 0 0 1-2.9.668Z"
            fill="#7FE2F4"
        />
        <path
            d="m560.934 473.758-2.426-1.41v-.516l2.426 1.41v.516Z"
            fill="#002F4A"
        />
        <path
            d="m560.931 473.242-2.426-1.41 2.369-1.354 2.426 1.41-2.369 1.354Z"
            fill="#0370A3"
        />
        <path
            d="M563.3 471.889v.516l-2.369 1.353v-.515l2.369-1.354Z"
            fill="#004266"
        />
        <path
            d="m561.018 472.503-.939-.546-.034-21.388.939.546.034 21.388Z"
            fill="#002F4A"
        />
        <path
            d="m560.989 451.116-.939-.546.825-.477.939.546-.825.477Z"
            fill="#0A2A44"
        />
        <path
            d="m561.809 450.639.034 21.388-.825.476-.029-21.387.82-.477Z"
            fill="#003959"
        />
        <path
            d="m549.914 467.353-2.426-1.41v-.516l2.426 1.41v.516Z"
            fill="#002F4A"
        />
        <path
            d="m549.911 466.837-2.426-1.41 2.368-1.354 2.426 1.41-2.368 1.354Z"
            fill="#0370A3"
        />
        <path
            d="M552.279 465.484V466l-2.368 1.353v-.515l2.368-1.354Z"
            fill="#004266"
        />
        <path
            d="m549.031 448.327.028 17.225.939.546-.028-17.771h-.939Z"
            fill="#002F4A"
        />
        <path
            d="m549.971 448.327.028 17.771.825-.476-.028-17.295h-.825Z"
            fill="#003959"
        />
        <path
            d="m560.908 456.222-13.419-7.812v-1.371l13.419 7.813v1.37Z"
            fill="#003959"
        />
        <path
            d="M601.636 431.335v1.371l-40.728 23.516v-1.371l40.728-23.516Z"
            fill="#134663"
        />
        <path
            d="M564.289 447.932c-.31.529-.764.958-1.309 1.24a7.971 7.971 0 0 1-7.241-.073c-1.624-.978-1.834-2.431-.7-3.549l-2.487-1.44-5.063 2.928 13.419 7.813 7.577-4.374-4.196-2.545Z"
            fill="#02567D"
        />
        <path
            d="M556.416 426.481a6.057 6.057 0 0 1 2.893-.668 5.958 5.958 0 0 1 2.98.723 1.788 1.788 0 0 1 .935 1.112.953.953 0 0 0 .032-.15 1.638 1.638 0 0 0-.967-1.3 5.958 5.958 0 0 0-2.98-.723 6.057 6.057 0 0 0-2.893.668 1.784 1.784 0 0 0-1.083 1.343.913.913 0 0 0 .032.188 1.91 1.91 0 0 1 1.051-1.193ZM576.089 415.118a6.057 6.057 0 0 1 2.893-.668 5.958 5.958 0 0 1 2.98.723 1.806 1.806 0 0 1 .934 1.112.955.955 0 0 0 .033-.15 1.645 1.645 0 0 0-.967-1.3 5.966 5.966 0 0 0-2.973-.725 6.057 6.057 0 0 0-2.893.668 1.78 1.78 0 0 0-1.083 1.344.913.913 0 0 0 .032.188 1.895 1.895 0 0 1 1.044-1.192ZM566.431 420.573a6.05 6.05 0 0 1 2.892-.667 5.965 5.965 0 0 1 2.981.723 1.795 1.795 0 0 1 .934 1.112.965.965 0 0 0 .032-.151 1.637 1.637 0 0 0-.966-1.3 5.975 5.975 0 0 0-2.981-.723 6.039 6.039 0 0 0-2.892.668 1.769 1.769 0 0 0-1.084 1.343.87.87 0 0 0 .033.189 1.9 1.9 0 0 1 1.051-1.194ZM585.854 409.292a6.06 6.06 0 0 1 2.893-.668 5.956 5.956 0 0 1 2.98.723 1.788 1.788 0 0 1 .935 1.112.852.852 0 0 0 .032-.15 1.629 1.629 0 0 0-.311-.777 1.651 1.651 0 0 0-.656-.523 5.956 5.956 0 0 0-2.98-.723 6.06 6.06 0 0 0-2.893.668 1.79 1.79 0 0 0-1.083 1.343c.005.064.016.127.032.188a1.912 1.912 0 0 1 1.051-1.193Z"
            fill="#38D7F4"
        />
        <path
            d="M647.386 481.522c-6.722 3.877-6.721 10.161 0 14.036l26.105 15.052M727.226 434.751c-6.722 3.877-6.721 10.161 0 14.036l26.105 15.052M645.375 424.552l37.664 21.718c6.722 3.876 17.62 3.876 24.341 0"
            stroke="#DEDDE2"
        />
        <path
            d="M778.896 428.917c.689-.4 1.257-.073 1.262.719l.071 25.81a2.76 2.76 0 0 1-1.253 2.165l-40.68 23.487c-.691.4-1.259.08-1.261-.712l-.073-25.812a2.772 2.772 0 0 1 1.253-2.17l40.681-23.487Z"
            fill="#89C6C1"
        />
        <path
            d="M809.186 474.519c0 .03-.003.06-.008.09 0 .029 0 .059-.008.088l-.019.079a1.15 1.15 0 0 1-.024.087c-.009.028-.02.048-.031.071a.778.778 0 0 1-.042.093c-.01.023-.026.044-.038.066a1.52 1.52 0 0 1-.066.1l-.05.06a1.11 1.11 0 0 1-.112.125c-.02.019-.039.041-.06.06a2.153 2.153 0 0 1-.261.202c-.047.033-.1.065-.148.1l-15.976 9.221V484l-3.53-2.053 5.1-2.958v-.38l.331.191 6.927-4.02-.009-2.417-3.24-1.874-.745.432v-.862l-1.085-.628-2.156-1.246-3.754-2.17-.937.543v-1.087l-3.241-1.873-.727.42v-.841l-3.238-1.872-3.357 1.947v.744l-.644-.371-3.357 1.949v.74l-.643-.371-3.356 1.95v.742l-.643-.372-3.353 1.95v.744l-.645-.373-3.365 1.942v.743l-.64-.371-3.36 1.95v.741l-.64-.371-3.36 1.95v.741l-.64-.369-3.357 1.947v.741l-.64-.369-3.36 1.948.007 2.416 1.878 1.086-.8.465v-.841l-3.24-1.873-3.357 1.95.007 2.417 3.237 1.872.728-.423v.842l3.239 1.875.727-.422v.842l3.242 1.873.721-.42v.84l3.243 1.873.744-.432v.863l3.24 1.874 7.116-4.129v-.484l.418.243 5.248-3.046v-.554l.477.276 1.92-1.113v.926l3.522 2.051-13.062 7.541a3.116 3.116 0 0 1-.416.2l-.122.045c-.1.033-.192.062-.291.088-.099.026-.176.047-.265.065a4.323 4.323 0 0 1-.378.065c-.025 0-.05.007-.075.009a5.163 5.163 0 0 1-.5.029h-.061a4.61 4.61 0 0 1-.486-.029l-.081-.007a4.76 4.76 0 0 1-.468-.08c-.028-.008-.06-.014-.09-.022a3.931 3.931 0 0 1-.471-.146 3.033 3.033 0 0 1-.454-.214l-24.369-14.161a1.464 1.464 0 0 1-.856-1.2c0 .804.002 1.61.007 2.416a1.46 1.46 0 0 0 .855 1.2l24.371 14.162c.141.082.288.153.441.211h.01l.049.016c.1.037.2.07.3.1.041.012.084.02.126.03l.094.023c.029.007.057.016.087.021.1.019.194.036.293.048.029.006.059.008.087.011l.073.008c.042 0 .085.01.126.013.098.008.195.013.291.015h.301c.11 0 .218-.011.326-.022h.027c.025 0 .049-.007.073-.011.091-.012.182-.021.271-.038.037-.006.071-.02.109-.026.088-.018.173-.041.259-.063.053-.016.108-.024.16-.04.052-.016.093-.035.139-.053.046-.018.079-.027.119-.043.143-.056.282-.123.415-.2l42.366-24.462c.034-.02.066-.037.1-.058a.375.375 0 0 1 .05-.036c.033-.021.064-.044.093-.066.029-.022.061-.046.09-.072.029-.026.052-.042.076-.064s.024-.018.033-.029a3.103 3.103 0 0 0 .173-.192 1.448 1.448 0 0 0 .084-.128c.01-.018.023-.034.031-.049l.008-.016c.017-.032.029-.065.044-.1.015-.035.018-.035.024-.053v-.012c.011-.031.018-.064.026-.1a.584.584 0 0 0 .015-.06v-.013a.551.551 0 0 0 .01-.09c0-.023.006-.045.006-.066v-.02l-.003-2.41Z"
            fill="#003959"
        />
        <path
            d="m808.335 473.32-24.371-14.162a4.62 4.62 0 0 0-4.177 0l-42.366 24.461a1.28 1.28 0 0 0-.014 2.419l24.369 14.161a4.616 4.616 0 0 0 4.175 0l42.368-24.46a1.283 1.283 0 0 0 .635-1.947 1.277 1.277 0 0 0-.619-.472Z"
            fill="#02567D"
        />
        <path
            d="m780.326 466.886 3.24 1.871-3.357 1.951-3.241-1.875 3.358-1.947ZM785.496 468.481l3.241 1.874-3.357 1.948-3.242-1.874 3.358-1.948Z"
            fill="#D7E7F7"
        />
        <path
            d="m790.174 466.014 3.754 2.17 2.155 1.246 1.085.628-5.666 3.289-3.24-1.874 1.741-1.011-3.755-2.173 3.926-2.275ZM781.72 470.673l3.241 1.875-3.357 1.948-3.241-1.875 3.357-1.948ZM797.916 470.488l3.24 1.874-6.923 4.021-3.243-1.874 6.926-4.021ZM790.661 474.699l3.241 1.874-5.247 3.044-3.243-1.873 5.249-3.045ZM780.315 476.086l3.238 1.873-3.354 1.949-3.241-1.874 3.357-1.948ZM782.026 461.304l3.238 1.872-3.354 1.95-3.241-1.875 3.357-1.947ZM778.026 463.626l3.242 1.871-3.358 1.952-3.241-1.874 3.357-1.949ZM785.992 463.597l3.241 1.873-5.2 3.019-3.244-1.872 5.203-3.02ZM774.026 465.942l3.242 1.874-3.358 1.947-3.241-1.871 3.357-1.95ZM770.026 468.262l3.242 1.875-3.357 1.947-3.239-1.872 3.354-1.95ZM776.503 469.102l3.243 1.874-3.358 1.948-3.24-1.873 3.355-1.949ZM766.035 470.583l3.241 1.874-3.357 1.948-3.243-1.879 3.359-1.943ZM772.682 471.326l3.243 1.873-3.36 1.948-3.241-1.873 3.358-1.948ZM787.826 471.726l3.241 1.875-3.357 1.949-3.239-1.875 3.355-1.949ZM762.039 472.902l3.24 1.875-3.36 1.949-3.241-1.875 3.361-1.949ZM777.94 472.866l3.241 1.873-3.354 1.949-3.243-1.872 3.356-1.95ZM768.862 473.539l3.241 1.874-3.357 1.948-3.242-1.874 3.358-1.948ZM784.05 473.917l3.242 1.874-3.358 1.948-3.244-1.873 3.36-1.949ZM774.164 475.057l3.242 1.875-3.357 1.948-3.242-1.875 3.357-1.948ZM758.041 475.226l3.241 1.876-3.358 1.946-3.243-1.872 3.36-1.95ZM765.043 475.756l3.239 1.873-3.354 1.951-3.244-1.875 3.359-1.949ZM770.388 477.25l3.238 1.876-3.359 1.95-3.243-1.874 3.364-1.952ZM754.043 477.544l3.242 1.874-3.359 1.948-3.24-1.875 3.357-1.947ZM761.218 477.974l3.242 1.873-3.356 1.948-3.239-1.872 3.353-1.949ZM776.414 478.35l3.239 1.874-3.358 1.95-3.241-1.875 3.36-1.949ZM766.61 479.44l3.241 1.875-3.354 1.949-3.245-1.872 3.358-1.952ZM750.048 479.863l3.241 1.873-3.361 1.95-3.241-1.875 3.361-1.948ZM757.399 480.191l3.241 1.876-3.358 1.948-3.243-1.874 3.36-1.95ZM772.677 480.518l3.241 1.875-3.358 1.947-3.242-1.874 3.359-1.948ZM762.833 481.633l3.241 1.876-3.36 1.948-3.242-1.875 3.361-1.949ZM768.901 482.71l3.241 1.874-3.358 1.948-3.241-1.874 3.358-1.948ZM744.531 483.064l3.24 1.873-3.359 1.95-3.239-1.873 3.358-1.95ZM759.056 483.826l3.242 1.873-3.358 1.948-3.243-1.873 3.359-1.948ZM785.071 477.945l3.241 1.874-14.75 8.56-3.241-1.873 14.75-8.561ZM765.164 484.88l3.24 1.872-3.357 1.951-3.241-1.875 3.358-1.948ZM753.409 482.508l3.241 1.874-8.27 4.8-3.24-1.874 8.269-4.8ZM787.561 481.221l4.78 2.778-12.078 6.971-4.781-2.778 12.079-6.971ZM755.264 486.026l3.244 1.873-6.158 3.571-3.241-1.873 6.155-3.571ZM769.844 486.782l3.241 1.873-5.246 3.047-3.241-1.876 5.246-3.044ZM761.345 487.094l3.241 1.874-8.269 4.8-3.241-1.873 8.269-4.801ZM764.179 490.069l3.24 1.874-7.113 4.129-3.244-1.874 7.117-4.129Z"
            fill="#D7E7F7"
        />
        <path
            d="m780.999 426.008-.075-.044-.6-.347-.6-.347a1.484 1.484 0 0 0-1.491.144l-42.366 24.461a4.62 4.62 0 0 0-2.088 3.613l.079 28.186a1.46 1.46 0 0 0 .614 1.34l1.492.869a1.47 1.47 0 0 1-.615-1.342l-.078-28.186a4.62 4.62 0 0 1 2.088-3.614l42.368-24.46a1.469 1.469 0 0 1 1.488-.143l-.216-.13Z"
            fill="#003959"
        />
        <path
            d="M779.734 426.281c1.15-.665 2.1-.129 2.1 1.194l.079 28.188a4.626 4.626 0 0 1-2.088 3.616l-42.368 24.462c-1.154.665-2.1.125-2.1-1.2l-.078-28.186a4.62 4.62 0 0 1 2.088-3.614l42.367-24.46Zm.495 29.165-.071-25.81c0-.792-.573-1.117-1.262-.719l-40.681 23.487a2.769 2.769 0 0 0-1.253 2.17l.073 25.812c0 .792.57 1.111 1.261.712l40.68-23.487a2.766 2.766 0 0 0 1.253-2.165Z"
            fill="#025A82"
        />
        <path
            d="M769.171 451.156a1.246 1.246 0 0 1 1.263.12c.61.543.37 1.851-.539 2.929a3.604 3.604 0 0 1-1.486 1.089 1.842 1.842 0 0 1-.568.111 1.022 1.022 0 0 1-.623-.175.501.501 0 0 1-.072-.057c-.608-.541-.371-1.84.529-2.916.221-.263.474-.499.753-.7a2.98 2.98 0 0 1 .743-.401Z"
            fill="#E54332"
        />
        <path
            d="M767.217 455.226c.184.124.402.186.623.175l-2.408 3.4a.903.903 0 0 0-.53-.309l2.315-3.266ZM764.16 449.746a1.985 1.985 0 0 0-.05.808l-3.2 2.08a1.352 1.352 0 0 0-.148-.681l3.398-2.207ZM755.242 452.901c.21-.268.385-.561.521-.873l2.121.589a4.277 4.277 0 0 0-.588.855l-2.054-.571Z"
            fill="#F9FDFF"
        />
        <path
            d="M759.31 451.598a1.247 1.247 0 0 1 1.263.12.919.919 0 0 1 .186.235c.109.21.16.445.148.681a3.438 3.438 0 0 1-.873 2.013 3.978 3.978 0 0 1-.944.825 2.752 2.752 0 0 1-.543.264c-.09.032-.183.058-.277.078a1.102 1.102 0 0 1-.986-.2c-.467-.415-.435-1.278.012-2.143a4.277 4.277 0 0 1 .588-.855 3.553 3.553 0 0 1 1.426-1.018Z"
            fill="#09455F"
        />
        <path
            d="M758.547 455.736c.19-.068.372-.156.543-.264l-.543 2.952a1.878 1.878 0 0 0-.514.109 2.469 2.469 0 0 0-.286.12l.523-2.839c.094-.02.187-.046.277-.078Z"
            fill="#F9FDFF"
        />
        <path
            d="M758.034 458.533c.165-.06.338-.097.514-.109a1.01 1.01 0 0 1 .749.229 1.413 1.413 0 0 1 .264 1.419 3.48 3.48 0 0 1-.365.883 4.23 4.23 0 0 1-.438.623 3.598 3.598 0 0 1-1.486 1.092 1.239 1.239 0 0 1-1.263-.124.873.873 0 0 1-.154-.178 1.236 1.236 0 0 1-.183-.657c.04-.777.349-1.515.875-2.089.33-.401.738-.73 1.2-.969.093-.046.189-.086.287-.12Z"
            fill="#FCC20B"
        />
        <path
            d="M759.195 460.955c.162-.276.285-.573.365-.883l2.75-.045a3.87 3.87 0 0 0-.452.885l-2.663.043ZM767.685 452.245l-.01.012-1.043-1.522a4.312 4.312 0 0 0 .717-.758l1.079 1.576a4.132 4.132 0 0 0-.743.692Z"
            fill="#F9FDFF"
        />
        <path
            d="M743.214 452.862a1.253 1.253 0 0 1 1.264.12c.52.463.421 1.484-.184 2.443a4.111 4.111 0 0 1-.666.816 3.335 3.335 0 0 1-1.176.759 1.244 1.244 0 0 1-1.263-.121c-.61-.543-.369-1.851.539-2.928a3.613 3.613 0 0 1 1.486-1.089Z"
            fill="#E54332"
        />
        <path
            d="m744.295 455.426 1.945.781-.027.032a4.255 4.255 0 0 0-.546.822l-2.038-.819a4.41 4.41 0 0 0 .311-.33c.129-.154.248-.316.355-.486ZM770.827 442.126l3.085-.54a2.952 2.952 0 0 0-.265.87l-3.1.543c.137-.275.231-.569.28-.873Z"
            fill="#F9FDFF"
        />
        <path
            d="M769.253 440.826a1.237 1.237 0 0 1 1.263.122 1.273 1.273 0 0 1 .312 1.181 3.02 3.02 0 0 1-.28.873 4.165 4.165 0 0 1-.572.874 3.588 3.588 0 0 1-1.485 1.089 2.323 2.323 0 0 1-.156.048c-.236.071-.486.08-.727.027a.898.898 0 0 1-.378-.2c-.61-.543-.369-1.85.539-2.928a3.615 3.615 0 0 1 1.484-1.086Z"
            fill="#09455F"
        />
        <path
            d="M766.451 447.148a2.2 2.2 0 0 1 .24-.07c.233-.06.478-.055.709.012a.895.895 0 0 1 .315.178c.568.507.4 1.679-.366 2.709a4.312 4.312 0 0 1-.717.758 3.17 3.17 0 0 1-.943.551 1.247 1.247 0 0 1-1.263-.121 1.018 1.018 0 0 1-.316-.611 1.985 1.985 0 0 1 .05-.808c.15-.557.423-1.072.8-1.509a3.604 3.604 0 0 1 1.491-1.089Z"
            fill="#FCC20B"
        />
        <path
            d="M767.608 445.038c.241.053.491.044.726-.027l-.935 2.079a1.333 1.333 0 0 0-.709-.012l.918-2.04ZM749.891 467.826c.244.048.496.034.733-.041l-1.138 2.529a1.23 1.23 0 0 0-.687-.063l1.092-2.425Z"
            fill="#F9FDFF"
        />
        <path
            d="M746.653 462.369a1.83 1.83 0 0 1 .553-.109c.257-.016.511.067.708.233a1.577 1.577 0 0 1 .172 1.727 3.9 3.9 0 0 1-.47.886c-.074.106-.154.21-.24.312a3.608 3.608 0 0 1-1.485 1.091 1.237 1.237 0 0 1-1.261-.124c-.611-.539-.37-1.85.538-2.924a3.787 3.787 0 0 1 1.242-.991c.082-.044.163-.072.243-.101Z"
            fill="#FCC20B"
        />
        <path
            d="M747.615 465.106c.195-.274.353-.572.47-.886l1.9.526a4.209 4.209 0 0 0-.548.864l-1.822-.504Z"
            fill="#F9FDFF"
        />
        <path
            d="M751.512 463.603a1.247 1.247 0 0 1 1.264.121c.089.08.162.177.214.285.101.223.142.468.119.712a3.506 3.506 0 0 1-.872 1.928 3.607 3.607 0 0 1-1.487 1.092 2.038 2.038 0 0 1-.126.04 1.481 1.481 0 0 1-.733.041.895.895 0 0 1-.4-.205c-.443-.391-.438-1.189-.055-2.007.146-.309.33-.6.548-.864l.045-.054c.392-.485.903-.86 1.483-1.089Z"
            fill="#E54332"
        />
        <path
            d="m752.989 464.009 2.682-2.3c-.001.232.062.459.183.657l-2.746 2.353a1.397 1.397 0 0 0-.119-.71Z"
            fill="#F9FDFF"
        />
        <path
            d="M747.699 455.149a1.237 1.237 0 0 1 1.263.12c.139.126.238.29.285.472.065.262.07.536.013.8a3.74 3.74 0 0 1-.837 1.653 4.211 4.211 0 0 1-.572.561 3.233 3.233 0 0 1-.85.5l-.064.024a1.247 1.247 0 0 1-1.263-.121c-.46-.409-.436-1.254-.007-2.106.149-.294.333-.57.546-.822l.027-.032a3.577 3.577 0 0 1 1.459-1.049Z"
            fill="#09455F"
        />
        <path
            d="m749.246 455.741 2.807-2.406c.021.221.108.43.25.6l-3.044 2.609a1.77 1.77 0 0 0-.013-.803ZM746.409 462.47l.591-3.207a3.19 3.19 0 0 0 .85-.5l-.645 3.5a1.835 1.835 0 0 0-.553.109c-.08.026-.161.054-.243.098Z"
            fill="#F9FDFF"
        />
        <path
            d="M754.402 449.999a1.237 1.237 0 0 1 1.261.122 1.67 1.67 0 0 1 .1 1.907 4.018 4.018 0 0 1-.638 1.017 3.595 3.595 0 0 1-1.485 1.092 1.231 1.231 0 0 1-1.261-.124 1.106 1.106 0 0 1-.076-.077 1.097 1.097 0 0 1-.25-.6 3.195 3.195 0 0 1 .864-2.247 3.605 3.605 0 0 1 1.485-1.09Z"
            fill="#E54332"
        />
        <path
            d="M775.993 439.578a1.247 1.247 0 0 1 1.263.121c.611.539.369 1.851-.539 2.925a3.598 3.598 0 0 1-1.486 1.092 1.237 1.237 0 0 1-1.263-.124 1.255 1.255 0 0 1-.32-1.135c.043-.302.133-.595.265-.87.157-.331.356-.64.593-.919a3.618 3.618 0 0 1 1.487-1.09Z"
            fill="#FCC20B"
        />
        <path
            d="M764.071 458.577c.265-.103.553-.134.834-.088a.908.908 0 0 1 .53.309c.481.592.218 1.811-.637 2.826a3.6 3.6 0 0 1-1.487 1.089 1.247 1.247 0 0 1-1.263-.121 1.546 1.546 0 0 1-.187-1.682c.111-.314.263-.611.452-.885.085-.125.177-.245.274-.361a3.602 3.602 0 0 1 1.484-1.087Z"
            fill="#09455F"
        />
        <path
            d="M748.455 470.337c.112-.04.227-.07.344-.09.23-.045.468-.023.687.063a.903.903 0 0 1 .233.148c.61.539.369 1.85-.539 2.924a3.592 3.592 0 0 1-1.487 1.092 1.239 1.239 0 0 1-1.263-.123c-.61-.539-.369-1.851.539-2.925a3.591 3.591 0 0 1 1.486-1.089Z"
            fill="#E54332"
        />
        <path
            d="m837.198 464.12 18.835-10.946.007-2.411-18.835 10.946-.007 2.411Z"
            fill="#003959"
        />
        <path
            d="m837.205 461.709 18.835-10.947-40.006-23.1-18.835 10.946 40.006 23.101Z"
            fill="#02567D"
        />
        <path
            d="m821.675 455.162 15.523 8.962.007-2.412-40.006-23.1-.007 2.412 24.483 14.138Z"
            fill="#134663"
        />
        <path
            d="M814.606 414.402a7.83 7.83 0 0 0-7.112.072 2.266 2.266 0 0 0-1.339 2.376l-4.312 2.669-3.393-1.957 13.18-7.674 6.409 3.7-2.567 1.482a3.725 3.725 0 0 0-.866-.668Z"
            fill="#02567D"
        />
        <path
            d="M814.887 397.468v38.461a3.76 3.76 0 0 1-3.763 3.764 3.762 3.762 0 0 1-3.764-3.764v-38.461h7.527Z"
            fill="#ADE9F4"
        />
        <path
            d="M814.239 411.185v24.743a3.11 3.11 0 0 1-1.91 2.929 3.118 3.118 0 0 1-4.1-1.719 3.132 3.132 0 0 1-.221-1.21v-24.743h6.231Z"
            fill="#19A603"
        />
        <path
            d="M813.28 409.887c1.242.692 1.283 1.834.091 2.551a4.851 4.851 0 0 1-4.4.045c-1.241-.692-1.282-1.835-.091-2.552a4.85 4.85 0 0 1 4.4-.044Z"
            fill="#54DE29"
        />
        <path
            d="M815.662 397.636v-.681a2.218 2.218 0 0 1-1.263 1.813 7.06 7.06 0 0 1-6.418.065 2.297 2.297 0 0 1-1.4-1.9v.682a2.297 2.297 0 0 0 1.4 1.9 7.072 7.072 0 0 0 6.418-.065 2.232 2.232 0 0 0 1.263-1.814Z"
            fill="#7FE2F4"
        />
        <path
            d="M814.266 395.05c1.809 1.009 1.868 2.674.133 3.718a7.06 7.06 0 0 1-6.418.065c-1.809-1.009-1.869-2.673-.133-3.718a7.072 7.072 0 0 1 6.418-.065Z"
            fill="#ADE9F4"
        />
        <path
            d="M811.136 398.923a5.85 5.85 0 0 0 2.928-.71 1.606 1.606 0 0 0 .949-1.277 1.748 1.748 0 0 0-1.064-1.32 5.952 5.952 0 0 0-2.841-.655 5.865 5.865 0 0 0-2.927.71 1.612 1.612 0 0 0-.95 1.277 1.752 1.752 0 0 0 1.064 1.319 5.944 5.944 0 0 0 2.841.656Z"
            fill="#7FE2F4"
        />
        <path
            d="m803.709 439.287 2.383-1.385v-.506l-2.383 1.385v.506Z"
            fill="#002F4A"
        />
        <path
            d="m803.711 438.78 2.383-1.385-2.326-1.329-2.383 1.385 2.326 1.329Z"
            fill="#0370A3"
        />
        <path
            d="M801.385 437.451v.506l2.326 1.329v-.506l-2.326-1.329Z"
            fill="#004266"
        />
        <path
            d="m804.575 419.911-.028 17.608-.923.536.029-18.144h.922Z"
            fill="#002F4A"
        />
        <path
            d="m803.654 419.911-.029 18.144-.811-.468.028-17.676h.812Z"
            fill="#003959"
        />
        <path
            d="M806.156 416.85a2.75 2.75 0 0 0 1.486 1.744 7.838 7.838 0 0 0 7.112-.072c1.579-.951 1.8-2.359.719-3.453l2.567-1.482 9.613 5.55-2.55 1.472a3.718 3.718 0 0 0-.91-.712 7.842 7.842 0 0 0-7.112.072c-1.34.806-1.692 1.943-1.118 2.938l-4.007 2.455-10.112-5.839 4.312-2.673Z"
            fill="#02567D"
        />
        <path
            d="M824.473 403.151v38.461a3.763 3.763 0 1 1-7.527 0v-38.461h7.527Z"
            fill="#ADE9F4"
        />
        <path
            d="M823.825 416.868v24.744a3.124 3.124 0 0 1-.892 2.24 3.114 3.114 0 0 1-2.223.932 3.104 3.104 0 0 1-2.223-.932 3.127 3.127 0 0 1-.893-2.24v-24.744h6.231Z"
            fill="#19A603"
        />
        <path
            d="M822.866 415.57c1.242.692 1.283 1.835.092 2.552a4.863 4.863 0 0 1-4.4.044c-1.242-.692-1.283-1.835-.092-2.552a4.85 4.85 0 0 1 4.4-.044Z"
            fill="#54DE29"
        />
        <path
            d="M825.248 403.32v-.682a2.22 2.22 0 0 1-1.264 1.813 7.06 7.06 0 0 1-6.418.065 2.29 2.29 0 0 1-.962-.757 2.292 2.292 0 0 1-.438-1.143v.681c.04.414.191.809.438 1.143.246.335.579.597.962.757a7.072 7.072 0 0 0 6.418-.065 2.221 2.221 0 0 0 1.264-1.812Z"
            fill="#7FE2F4"
        />
        <path
            d="M823.852 400.733c1.809 1.009 1.869 2.674.133 3.718a7.053 7.053 0 0 1-3.201.803 7.054 7.054 0 0 1-3.217-.738c-1.809-1.009-1.868-2.673-.133-3.718a7.073 7.073 0 0 1 6.418-.065Z"
            fill="#ADE9F4"
        />
        <path
            d="M820.72 404.606a5.85 5.85 0 0 0 2.927-.71 1.606 1.606 0 0 0 .95-1.277 1.74 1.74 0 0 0-1.065-1.319 5.934 5.934 0 0 0-2.84-.656 5.866 5.866 0 0 0-2.928.71 1.603 1.603 0 0 0-.949 1.277 1.745 1.745 0 0 0 1.064 1.319 5.932 5.932 0 0 0 2.841.656Z"
            fill="#7FE2F4"
        />
        <path
            d="M815.962 422.907c.306.502.744.911 1.265 1.182a7.828 7.828 0 0 0 7.112-.072c1.558-.938 1.788-2.32.763-3.408l2.55-1.472 8.868 5.125-2.383 1.376a4.04 4.04 0 0 0-.457-.311 7.839 7.839 0 0 0-7.112.072c-1.256.755-1.647 1.8-1.221 2.75l-4.186 2.529-9.206-5.316 4.007-2.455Z"
            fill="#02567D"
        />
        <path
            d="M833.965 408.51v38.461a3.763 3.763 0 1 1-7.527 0V408.51h7.527Z"
            fill="#ADE9F4"
        />
        <path
            d="M833.32 422.227v24.743a3.11 3.11 0 0 1-1.91 2.929 3.114 3.114 0 0 1-4.321-2.929v-24.743h6.231Z"
            fill="#19A603"
        />
        <path
            d="M832.358 420.929c1.241.692 1.282 1.834.091 2.551a4.851 4.851 0 0 1-4.4.045c-1.242-.693-1.283-1.835-.091-2.552a4.85 4.85 0 0 1 4.4-.044Z"
            fill="#54DE29"
        />
        <path
            d="M834.739 408.678v-.681a2.22 2.22 0 0 1-1.264 1.813 7.057 7.057 0 0 1-6.418.065 2.297 2.297 0 0 1-1.4-1.9v.682a2.297 2.297 0 0 0 1.4 1.9 7.066 7.066 0 0 0 6.418-.065 2.22 2.22 0 0 0 1.264-1.814Z"
            fill="#7FE2F4"
        />
        <path
            d="M833.344 406.092c1.809 1.009 1.869 2.673.133 3.718a7.06 7.06 0 0 1-6.418.065c-1.809-1.009-1.868-2.673-.133-3.718a7.065 7.065 0 0 1 6.418-.065Z"
            fill="#ADE9F4"
        />
        <path
            d="M830.216 409.962a5.854 5.854 0 0 0 2.927-.71 1.615 1.615 0 0 0 .95-1.277 1.756 1.756 0 0 0-1.064-1.32 5.944 5.944 0 0 0-2.841-.656 5.837 5.837 0 0 0-2.927.711 1.606 1.606 0 0 0-.95 1.276 1.739 1.739 0 0 0 1.064 1.32 5.938 5.938 0 0 0 2.841.656Z"
            fill="#7FE2F4"
        />
        <path
            d="M843.379 430.888a7.843 7.843 0 0 0-7.112.072c-1.323.8-1.682 1.915-1.138 2.9l-4.115 2.5-3.059-1.767-6.791-3.92 4.186-2.529a3.055 3.055 0 0 0 1.37 1.371 7.842 7.842 0 0 0 7.112-.071c1.757-1.058 1.834-2.683.309-3.809l2.379-1.373 4.668 2.695 5.469 3.157-2.445 1.412a3.801 3.801 0 0 0-.833-.638Z"
            fill="#02567D"
        />
        <path
            d="M843.801 414.313v38.46a3.765 3.765 0 1 1-7.528 0v-38.46h7.528Z"
            fill="#ADE9F4"
        />
        <path
            d="M843.154 428.029v24.744a3.113 3.113 0 0 1-3.116 3.116 3.113 3.113 0 0 1-3.116-3.116v-24.744h6.232Z"
            fill="#19A603"
        />
        <path
            d="M842.194 426.731c1.242.692 1.282 1.835.091 2.552a4.85 4.85 0 0 1-4.4.044c-1.242-.692-1.282-1.835-.091-2.551a4.851 4.851 0 0 1 4.4-.045Z"
            fill="#54DE29"
        />
        <path
            d="M844.575 414.481v-.682a2.228 2.228 0 0 1-1.263 1.813 7.06 7.06 0 0 1-6.419.065 2.297 2.297 0 0 1-1.4-1.9v.681a2.297 2.297 0 0 0 1.4 1.9 7.08 7.08 0 0 0 6.419-.065 2.23 2.23 0 0 0 1.263-1.812Z"
            fill="#7FE2F4"
        />
        <path
            d="M843.181 411.895c1.809 1.008 1.868 2.673.133 3.717a7.064 7.064 0 0 1-6.419.065c-1.809-1.008-1.868-2.673-.133-3.717a7.07 7.07 0 0 1 6.419-.065Z"
            fill="#ADE9F4"
        />
        <path
            d="M840.051 415.762a5.85 5.85 0 0 0 2.927-.71 1.604 1.604 0 0 0 .95-1.277 1.74 1.74 0 0 0-1.063-1.319 5.945 5.945 0 0 0-2.842-.656 5.854 5.854 0 0 0-2.927.71 1.615 1.615 0 0 0-.95 1.277 1.742 1.742 0 0 0 1.064 1.319 5.944 5.944 0 0 0 2.841.656ZM811.137 398.923a5.85 5.85 0 0 0 2.928-.71 1.606 1.606 0 0 0 .949-1.277 1.748 1.748 0 0 0-1.064-1.32 5.952 5.952 0 0 0-2.841-.655 5.865 5.865 0 0 0-2.927.71 1.612 1.612 0 0 0-.95 1.277 1.752 1.752 0 0 0 1.064 1.319 5.944 5.944 0 0 0 2.841.656ZM820.695 400.644a5.86 5.86 0 0 0-2.927.71 1.612 1.612 0 0 0-.949 1.277c.051.292.175.567.361.798.187.23.429.41.703.521a5.932 5.932 0 0 0 2.841.656 5.85 5.85 0 0 0 2.927-.71 1.604 1.604 0 0 0 .95-1.277 1.74 1.74 0 0 0-1.064-1.319 5.956 5.956 0 0 0-2.842-.656ZM830.216 409.962a5.854 5.854 0 0 0 2.927-.71 1.615 1.615 0 0 0 .95-1.277 1.756 1.756 0 0 0-1.064-1.32 5.944 5.944 0 0 0-2.841-.656 5.837 5.837 0 0 0-2.927.711 1.606 1.606 0 0 0-.95 1.276 1.739 1.739 0 0 0 1.064 1.32 5.938 5.938 0 0 0 2.841.656Z"
            fill="#7FE2F4"
        />
        <path
            d="m838.428 459.228 2.383-1.385v-.506l-2.383 1.385v.506Z"
            fill="#002F4A"
        />
        <path
            d="m838.43 458.722 2.383-1.385-2.326-1.329-2.383 1.385 2.326 1.329Z"
            fill="#0370A3"
        />
        <path
            d="M836.104 457.392v.506l2.326 1.329v-.506l-2.326-1.329Z"
            fill="#004266"
        />
        <path
            d="m838.344 457.996.922-.536.034-21.007-.922.536-.034 21.007Z"
            fill="#002F4A"
        />
        <path
            d="m838.377 436.989.922-.536-.811-.468-.922.536.811.468Z"
            fill="#0A2A44"
        />
        <path
            d="m837.567 436.521-.034 21.007.81.468.034-21.007-.81-.468Z"
            fill="#003959"
        />
        <path
            d="m849.252 452.937 2.383-1.385v-.506l-2.383 1.385v.506Z"
            fill="#002F4A"
        />
        <path
            d="m849.255 452.431 2.383-1.385-2.326-1.329-2.383 1.385 2.326 1.329Z"
            fill="#0370A3"
        />
        <path
            d="M846.928 451.102v.506l2.326 1.329v-.506l-2.326-1.329Z"
            fill="#004266"
        />
        <path
            d="m850.121 434.251-.027 16.919-.922.536.028-17.455h.921Z"
            fill="#002F4A"
        />
        <path
            d="m849.196 434.251-.028 17.455-.811-.468.027-16.987h.812Z"
            fill="#003959"
        />
        <path
            d="m838.453 442.005 13.18-7.674v-1.346l-13.18 7.674v1.346Z"
            fill="#003959"
        />
        <path
            d="M798.45 417.562v1.346l40.006 23.1v-1.346l-40.006-23.1Z"
            fill="#134663"
        />
        <path
            d="M835.13 433.862c.304.52.75.942 1.285 1.218a7.838 7.838 0 0 0 7.112-.072c1.6-.96 1.8-2.387.689-3.485l2.445-1.412 4.976 2.873-13.18 7.675-7.442-4.3 4.115-2.497Z"
            fill="#02567D"
        />
        <path
            d="M842.865 412.794a5.934 5.934 0 0 0-2.842-.657 5.84 5.84 0 0 0-2.927.711 1.768 1.768 0 0 0-.918 1.092 1.053 1.053 0 0 1-.032-.148 1.615 1.615 0 0 1 .95-1.277 5.865 5.865 0 0 1 2.927-.71 5.956 5.956 0 0 1 2.842.656 1.751 1.751 0 0 1 1.063 1.319.824.824 0 0 1-.032.185 1.862 1.862 0 0 0-1.031-1.171ZM823.537 401.632a5.945 5.945 0 0 0-2.842-.656 5.85 5.85 0 0 0-2.927.71 1.771 1.771 0 0 0-.918 1.093.926.926 0 0 1-.031-.148 1.604 1.604 0 0 1 .949-1.277 5.85 5.85 0 0 1 2.927-.71 5.945 5.945 0 0 1 2.842.656 1.739 1.739 0 0 1 1.064 1.319.885.885 0 0 1-.032.185 1.872 1.872 0 0 0-1.032-1.172ZM833.029 406.991a5.944 5.944 0 0 0-2.841-.656 5.85 5.85 0 0 0-2.927.71 1.761 1.761 0 0 0-.918 1.092.82.82 0 0 1-.032-.147 1.604 1.604 0 0 1 .95-1.277 5.847 5.847 0 0 1 2.927-.71 5.932 5.932 0 0 1 2.841.656 1.742 1.742 0 0 1 1.064 1.319 1.037 1.037 0 0 1-.032.185 1.88 1.88 0 0 0-1.032-1.172ZM813.95 395.91a5.937 5.937 0 0 0-2.841-.655 5.852 5.852 0 0 0-2.927.71 1.768 1.768 0 0 0-.918 1.092 1.053 1.053 0 0 1-.032-.148 1.615 1.615 0 0 1 .95-1.277 5.865 5.865 0 0 1 2.927-.71 5.938 5.938 0 0 1 2.841.656 1.739 1.739 0 0 1 1.064 1.319.885.885 0 0 1-.032.185 1.874 1.874 0 0 0-1.032-1.172Z"
            fill="#38D7F4"
        />
        <path
            d="m601.825 416.346 41.512 24.124a7.672 7.672 0 0 0 6.931 0l31.244-18.039a2.444 2.444 0 0 0 1.44-2.021l.008 2.815a2.45 2.45 0 0 1-1.44 2.021l-31.244 18.039a7.669 7.669 0 0 1-6.931 0l-41.512-24.124a2.432 2.432 0 0 1-1.417-1.993l-.008-2.815a2.432 2.432 0 0 0 1.417 1.993Z"
            fill="#134663"
        />
        <path
            d="M601.848 412.331c-1.911 1.1-1.922 2.911-.023 4.015l41.512 24.124a7.675 7.675 0 0 0 6.931 0l31.244-18.039c1.911-1.1 1.921-2.911.022-4.014l-41.512-24.124a7.666 7.666 0 0 0-6.93 0l-31.244 18.038Z"
            fill="#02567D"
        />
        <path
            d="m625.365 400.538.008 2.731 1.1.638-.008-2.731-1.1-.638Z"
            fill="#919191"
        />
        <path
            d="m626.458 401.176.008 2.731a.514.514 0 0 1 .3.417l-.007-2.731a.51.51 0 0 0-.3-.417h-.001Z"
            fill="#BFBFBF"
        />
        <path
            d="m615.944 401.863.007 2.731a.631.631 0 0 1 .371-.518 1.961 1.961 0 0 1 1.77 0 .627.627 0 0 1 .366.513l-.008-2.732a.627.627 0 0 0-.366-.512 1.955 1.955 0 0 0-1.77 0 .633.633 0 0 0-.37.518ZM626.454 402.016l.007 2.731a.508.508 0 0 0 .3-.423l-.007-2.731a.509.509 0 0 1-.3.423Z"
            fill="#BC8430"
        />
        <path
            d="M613.698 405.862a.765.765 0 0 1-.1-.349l-.007-2.732a.994.994 0 0 0 .575.828l1.127.655.007 2.731-.418-.243.007 2.565-1.07-.622a.522.522 0 0 1-.3-.422l-.008-2.732a.441.441 0 0 0 .06.18.44.44 0 0 0 .127.141Z"
            fill="#8E6424"
        />
        <path
            d="m614.885 406.586.008 2.731 1.1.638-.008-2.731-1.1-.638Z"
            fill="#8E6424"
        />
        <path
            d="m617.434 407.224.008 2.731 9.021-5.208-.008-2.731-9.021 5.208Z"
            fill="#8F6424"
        />
        <path
            d="m615.983 407.224.007 2.731a1.604 1.604 0 0 0 1.45 0l-.007-2.731a1.6 1.6 0 0 1-1.45 0Z"
            fill="#BC8430"
        />
        <path
            d="m615.296 404.264-1.127-.655c-.815-.473-.76-1.285.138-1.8l2.81-1.622a3.447 3.447 0 0 1 3.107-.07l1.126.654 1.483-.856a1.608 1.608 0 0 1 1.457 0l1.07.622 1.1.638a.443.443 0 0 1 .298.42.444.444 0 0 1-.298.42l-9.021 5.208a1.6 1.6 0 0 1-1.45 0l-1.1-.638-1.07-.622a.447.447 0 0 1 0-.844l1.477-.855Zm2.789-1.89a.54.54 0 0 0 .265-.827.54.54 0 0 0-.265-.198 1.955 1.955 0 0 0-1.77 0 .542.542 0 0 0-.37.513.54.54 0 0 0 .364.516 1.964 1.964 0 0 0 1.777 0l-.001-.004Z"
            fill="#FFBF00"
        />
        <path
            d="M645.03 400.34c-1.612 3.63-5.094 6.481-8.528 8.334a36.176 36.176 0 0 1-15.8 4.041c-2.984.05-5.972-.314-8.947-.518a18.77 18.77 0 0 1-4.231-.95l-3.487 1.6v1.285l33.857 19.759 9.21 5.1.042-.025v-37.459l-2.116-1.167Z"
            fill="#D9D9D9"
        />
        <path
            d="m679.232 419.181-32.084-17.674v37.466l32.084-18.653v-1.139Z"
            fill="#E5E5E5"
        />
        <path
            d="m636.278 394.234-10.918 6.3 1.1.638a.448.448 0 0 1 .216.678.446.446 0 0 1-.216.162l-9.021 5.208a1.604 1.604 0 0 1-1.45 0l-1.1-.638-10.846 6.262 43.067 24.864 32.126-18.531-42.958-24.943Z"
            fill="#FDFDFD"
        />
        <path
            d="m647.32 402.454 22.812 13.17a2.905 2.905 0 0 1-1.322 2.156.92.92 0 0 1-.919.079l-21.343-12.4a.918.918 0 0 0 .918-.079c.01-.006.018-.017.028-.023l-1.332-.774a2.917 2.917 0 0 1 1.158-2.129Z"
            fill="#E54332"
        />
        <path
            d="m646.548 405.454 21.343 12.4a.94.94 0 0 1-.386-.875l-21.343-12.4a.936.936 0 0 0 .386.875ZM647.503 402.305a.932.932 0 0 1 .919-.079l21.343 12.4a.926.926 0 0 1 .386.875c0 .037-.016.078-.019.115l-22.812-13.162c.063-.049.119-.112.183-.149Z"
            fill="#A11E1A"
        />
        <path
            d="M668.225 417.925a1.093 1.093 0 0 1-.171-.627 2.9 2.9 0 0 1 1.342-2.271c.177-.103.379-.155.584-.15a.688.688 0 0 0-.214-.247l.548.318.8.467.557.324.408.237-.1-.053.152.089.078.044-.134-.08.267.155.063.042-.074-.044.011.006.022.013.043.025a.748.748 0 0 1 .216.282c0 .006.007.008.01.014.062.143.096.297.101.452v.086a2.3 2.3 0 0 1-.11.643c-.022.073-.063.141-.092.213a3.062 3.062 0 0 1-.19.421c-.046.08-.106.146-.159.221-.076.117-.16.229-.251.334a2.67 2.67 0 0 1-.207.176 2.612 2.612 0 0 1-.255.217l-.078.045c-.156.092-.33.149-.509.166a.72.72 0 0 1-.138-.029.696.696 0 0 1-.271-.057l-.676-.393-.557-.324a.709.709 0 0 1 .002 0l-.799-.466-.548-.319c.102.05.215.074.329.07Z"
            fill="#E54332"
        />
        <path
            d="M668.053 417.298v-.005l3.388 1.956-.049.028a1.223 1.223 0 0 1-.509.166.737.737 0 0 1-.138-.029.704.704 0 0 1-.271-.057l-.676-.393-.557-.324a.708.708 0 0 1 .003 0l-.8-.466-.548-.319a.687.687 0 0 0 .333.07 1.111 1.111 0 0 1-.176-.627Z"
            fill="#A11E1A"
        />
        <path
            d="m670.507 419.301 1.041.6a.896.896 0 0 1-.372-.845l-1.041-.6a.913.913 0 0 0 .372.845Z"
            fill="#BF8F00"
        />
        <path
            d="m673.357 416.792-1.041-.6a.89.89 0 0 0-.886.077 2.808 2.808 0 0 0-1.295 2.192l1.041.6a2.8 2.8 0 0 1 1.3-2.192.896.896 0 0 1 .881-.077Z"
            fill="#FFBF00"
        />
        <path
            d="M671.548 419.905c.315.185.678.269 1.043.242a1.794 1.794 0 0 0 1.592-1.281c.105-.35.1-.724-.013-1.071a1.83 1.83 0 0 0-.813-1 .897.897 0 0 0-.886.076 2.85 2.85 0 0 0-1.266 1.88 3.477 3.477 0 0 0-.012.568.795.795 0 0 0 .355.586Z"
            fill="#FAC93A"
        />
        <path
            d="m644.454 402.078.955 1.623a.62.62 0 0 1-.074-.327l-.881-1.296Z"
            fill="#A11E1A"
        />
        <path
            d="m646.337 402.104-1.883-.026.881 1.3a1.514 1.514 0 0 1 .7-1.183.62.62 0 0 1 .302-.091Z"
            fill="#E54332"
        />
        <path
            d="m645.41 403.703.9 1.5a1.195 1.195 0 0 1-.144-.631l-.827-1.2a.624.624 0 0 0 .071.331Z"
            fill="#BF8F00"
        />
        <path
            d="m648.09 402.137-1.751-.033a.616.616 0 0 0-.305.087 1.51 1.51 0 0 0-.7 1.183l.827 1.2a2.91 2.91 0 0 1 1.341-2.271c.178-.106.381-.163.588-.166Z"
            fill="#FFBF00"
        />
        <path
            d="m667.891 417.854.548.319a.94.94 0 0 1-.386-.876l-.548-.318a.936.936 0 0 0 .386.875Z"
            fill="#BF8F00"
        />
        <path
            d="m670.313 414.948-.548-.318a.919.919 0 0 0-.918.079 2.915 2.915 0 0 0-1.342 2.271l.548.318a2.91 2.91 0 0 1 1.342-2.271.928.928 0 0 1 .918-.079ZM671.673 415.739l-.556-.324a.925.925 0 0 0-.919.079 2.921 2.921 0 0 0-1.342 2.271l.557.324a2.91 2.91 0 0 1 1.342-2.271.923.923 0 0 1 .918-.079Z"
            fill="#FFBF00"
        />
        <path
            d="m669.242 418.64.557.324a.94.94 0 0 1-.386-.875l-.557-.324a.945.945 0 0 0 .386.875Z"
            fill="#BF8F00"
        />
        <path d="M669.414 418.044v.045l.065.037.01-.032-.075-.05Z" fill="#E54332" />
        <path
            d="M668.856 417.765a.937.937 0 0 0 .386.875l-.8-.466a.946.946 0 0 1-.386-.876l.8.467ZM671.43 416.264c-.027.015-.051.044-.078.061l-.716-.413c.042-.028.077-.071.119-.094a.916.916 0 0 1 .918-.079l.408.237-.1-.053.152.089.078.044-.134-.08.267.155a.69.69 0 0 1 .063.042l-.074-.044.012.006.021.013.043.025a.72.72 0 0 1 .1.126l-.192-.112a.89.89 0 0 0-.887.077ZM670.198 415.494c-.042.024-.078.067-.12.1l-.806-.465c.043-.028.08-.072.123-.1.125-.066.261-.11.4-.131.06-.011.121-.017.182-.018a.694.694 0 0 1 .336.07l.8.467a.915.915 0 0 0-.467-.083.916.916 0 0 0-.448.16Z"
            fill="#A11E1A"
        />
        <path
            d="M671.431 416.264a.886.886 0 0 1 .886-.077l.192.112.849.493a.814.814 0 0 0-.65 0 1.124 1.124 0 0 0-.236.077c-.027.015-.049.043-.075.059l-1.044-.6c.027-.02.051-.049.078-.064ZM668.847 414.709a.916.916 0 0 1 .918-.079l.548.318a.699.699 0 0 0-.336-.07.792.792 0 0 0-.182.018 1.128 1.128 0 0 0-.4.131c-.043.025-.08.069-.123.1l-.549-.317c.042-.032.08-.077.124-.101Z"
            fill="#BF8F00"
        />
        <path
            d="M669.396 415.027ZM671.673 415.739l-.557-.324.557.324Z"
            fill="#FFBF00"
        />
        <path
            d="M670.755 415.818c-.042.023-.077.066-.119.094l-.558-.323c.042-.028.078-.071.12-.1a.923.923 0 0 1 .919-.079l.556.324a.917.917 0 0 0-.918.084Z"
            fill="#BF8F00"
        />
        <path
            d="M639.007 412.322a.637.637 0 0 0 .127.337l-4.542.411a.572.572 0 0 0-.06-.342l4.475-.406ZM636.654 406.187l3.9 1.153a.896.896 0 0 0-.27.307l-3.957-1.171c.128-.073.239-.171.327-.289ZM639.244 401.224a.649.649 0 0 0 .147.334l-3.479.613a.584.584 0 0 0-.063-.351l3.395-.596Z"
            fill="#02567D"
        />
        <path
            d="M635.435 401.419c.114.064.217.146.305.243a.775.775 0 0 1 .108.158.57.57 0 0 1 .063.351c-.046.316-.363.611-.889.766-.099.028-.199.05-.3.067a2.803 2.803 0 0 1-.593.03 2.3 2.3 0 0 1-1-.273 1.166 1.166 0 0 1-.3-.241c-.414-.469-.1-1.04.706-1.274a2.588 2.588 0 0 1 1.9.173Z"
            fill="#E54332"
        />
        <path
            d="m634.723 403.004.5 1.863a2.761 2.761 0 0 0-.588.045l-.509-1.878c.199.011.4.001.597-.03Z"
            fill="#02567D"
        />
        <path
            d="M636.3 405.142c.112.064.213.146.3.242a.599.599 0 0 1 .053.8c-.09.118-.202.216-.331.289-.135.079-.279.14-.428.182a2.662 2.662 0 0 1-1.735-.089 1.645 1.645 0 0 1-.168-.084 1.21 1.21 0 0 1-.305-.243c-.408-.466-.091-1.037.718-1.275a2.756 2.756 0 0 1 .822-.1c.375.006.743.101 1.074.278Z"
            fill="#FFBF00"
        />
        <path
            d="M633.765 406.316c.071.065.149.122.232.169.055.031.111.059.168.084l-3.34 1.937a1.202 1.202 0 0 0-.177-.121 1.71 1.71 0 0 0-.252-.119l3.369-1.95Z"
            fill="#02567D"
        />
        <path
            d="M641.798 411.625c.114.064.217.146.305.243.407.466.09 1.036-.712 1.271a2.592 2.592 0 0 1-1.9-.172 1.187 1.187 0 0 1-.353-.308.637.637 0 0 1-.127-.337c-.02-.356.307-.7.892-.874a2.758 2.758 0 0 1 1.305-.041c.206.042.405.115.59.218Z"
            fill="#E54332"
        />
        <path
            d="M641.205 411.406a2.76 2.76 0 0 0-.588-.059l.686-2.536c.194.039.392.057.59.054l-.688 2.541ZM616.521 412.079a.621.621 0 0 0-.108.337l-3.178-.23a.58.58 0 0 0 .075-.341l3.211.234Z"
            fill="#02567D"
        />
        <path
            d="M622.674 415.688c.113.064.214.145.3.241.055.061.099.13.132.205a.562.562 0 0 1 .037.348 1.124 1.124 0 0 1-.875.722 2.588 2.588 0 0 1-1.9-.174 1.208 1.208 0 0 1-.3-.243c-.362-.413-.153-.908.462-1.181a2.202 2.202 0 0 1 .532-.156 2.54 2.54 0 0 1 1.612.238Z"
            fill="#FFBF00"
        />
        <path
            d="M627.102 416.261a.566.566 0 0 0 .05.346l-4.007-.125a.562.562 0 0 0-.037-.348l3.994.127Z"
            fill="#02567D"
        />
        <path
            d="M629.882 415.697c.038.022.075.046.111.071.071.049.136.107.194.172.414.462.091 1.036-.712 1.271a2.577 2.577 0 0 1-.5.093c-.2.016-.401.011-.6-.015a2.166 2.166 0 0 1-.783-.251 1.177 1.177 0 0 1-.3-.244.763.763 0 0 1-.127-.187.559.559 0 0 1-.05-.346c.056-.306.371-.591.883-.741a2.702 2.702 0 0 1 1.553.025c.115.04.226.091.331.152Z"
            fill="#E54332"
        />
        <path
            d="m628.971 417.304.432 1.591a2.768 2.768 0 0 0-.589.042l-.447-1.648c.2.027.403.032.604.015ZM632.175 413.821l-2.182 1.947a1.855 1.855 0 0 0-.455-.223l2.177-1.941a1.81 1.81 0 0 0 .46.217Z"
            fill="#02567D"
        />
        <path
            d="M630.643 408.385a1.202 1.202 0 0 1 .301.237c.366.416.159.912-.456 1.185a2.367 2.367 0 0 1-.533.157 2.54 2.54 0 0 1-1.62-.241 1.197 1.197 0 0 1-.306-.243.703.703 0 0 1-.162-.3.575.575 0 0 1 .027-.343 1.24 1.24 0 0 1 .847-.627 2.689 2.689 0 0 1 1.65.057c.087.032.172.072.252.118Z"
            fill="#E54332"
        />
        <path
            d="M634.118 412.324c.112.063.213.143.3.237a.917.917 0 0 1 .115.167.572.572 0 0 1 .06.342c-.045.317-.364.612-.887.769a2.71 2.71 0 0 1-1.53-.018 1.81 1.81 0 0 1-.46-.217 1.071 1.071 0 0 1-.212-.185c-.367-.41-.154-.907.458-1.179a2.353 2.353 0 0 1 .533-.156 2.541 2.541 0 0 1 1.623.24Z"
            fill="#FFBF00"
        />
        <path
            d="M632.215 412.148c-.086.025-.17.056-.252.092l-.76-.862-1.248-1.414a2.367 2.367 0 0 0 .533-.157l2.006 2.277a2.448 2.448 0 0 0-.279.064Z"
            fill="#02567D"
        />
        <path
            d="M619.204 411.754c.112.065.214.147.3.243.361.413.152.909-.46 1.179a2.052 2.052 0 0 1-.252.092 2.645 2.645 0 0 1-.28.065 2.54 2.54 0 0 1-1.621-.237 1.223 1.223 0 0 1-.3-.241.657.657 0 0 1-.181-.436.616.616 0 0 1 .108-.337c.196-.254.473-.432.785-.505a2.722 2.722 0 0 1 1.374-.026c.175.04.343.104.5.19l.027.013Z"
            fill="#FFBF00"
        />
        <path
            d="M618.798 413.265c.085-.025.17-.056.252-.092l2.007 2.277a2.124 2.124 0 0 0-.532.156l-2.007-2.276a2.52 2.52 0 0 0 .28-.065ZM620.846 409.615c.166.078.341.134.522.168l-2.187 1.955a1.968 1.968 0 0 0-.5-.19l2.165-1.933Z"
            fill="#02567D"
        />
        <path
            d="M623.037 408.213c.113.064.214.145.3.241a.74.74 0 0 1 .148.245c.04.11.044.23.012.342a1.167 1.167 0 0 1-.866.688 2.751 2.751 0 0 1-1.266.054 2.18 2.18 0 0 1-.638-.228 1.214 1.214 0 0 1-.305-.243c-.407-.465-.09-1.036.719-1.274a2.587 2.587 0 0 1 1.896.175Z"
            fill="#E54332"
        />
        <path
            d="M623.499 409.041a.555.555 0 0 0-.012-.342l4.407.137a.575.575 0 0 0-.027.343l-4.368-.138Z"
            fill="#02567D"
        />
        <path
            d="M612.83 411.226c.114.064.217.146.305.243a.667.667 0 0 1 .175.376.587.587 0 0 1-.075.341 1.333 1.333 0 0 1-.818.557 2.572 2.572 0 0 1-1.894-.174 1.251 1.251 0 0 1-.3-.242c-.407-.466-.09-1.037.713-1.271a2.562 2.562 0 0 1 1.894.17ZM642.03 400.495c.114.064.217.146.305.243.408.466.091 1.036-.712 1.271a2.587 2.587 0 0 1-1.9-.172 1.187 1.187 0 0 1-.3-.241c-.011-.013-.022-.025-.031-.038a.649.649 0 0 1-.147-.334c-.042-.367.287-.729.89-.906a2.585 2.585 0 0 1 1.895.177Z"
            fill="#E54332"
        />
        <path
            d="M630.465 419.172c.112.063.213.143.3.237.414.47.1 1.04-.712 1.278a2.584 2.584 0 0 1-1.9-.177 1.22 1.22 0 0 1-.306-.243c-.407-.465-.09-1.036.712-1.271a2.557 2.557 0 0 1 .837-.101c.374.006.74.101 1.069.277ZM643.002 407.247c.113.063.215.145.3.241.408.466.091 1.036-.712 1.271a2.586 2.586 0 0 1-.7.106 2.724 2.724 0 0 1-.59-.055 2.08 2.08 0 0 1-.609-.221 1.255 1.255 0 0 1-.3-.243.602.602 0 0 1-.11-.7.906.906 0 0 1 .27-.307c.167-.121.354-.211.552-.265a2.57 2.57 0 0 1 1.899.173ZM651.665 421.977c.14.079.266.181.374.3a.746.746 0 0 1 .045 1.006c-.117.147-.263.27-.429.359a2.268 2.268 0 0 1-.5.205 3.163 3.163 0 0 1-2.344-.21 1.498 1.498 0 0 1-.377-.3.743.743 0 0 1-.213-.433.746.746 0 0 1 .101-.473c.092-.15.216-.278.363-.375.112-.079.233-.146.36-.2.09-.039.182-.072.276-.1.159-.046.322-.08.487-.1a3.119 3.119 0 0 1 1.857.321Z"
            fill="#FFBF00"
        />
        <path
            d="m652.082 423.282 5.106 1.248a.812.812 0 0 0-.177.416l-5.358-1.3c.166-.091.312-.215.429-.364Z"
            fill="#02567D"
        />
        <path
            d="M656.553 429.086c.112.063.214.143.3.237.406.45.1 1-.688 1.233a2.505 2.505 0 0 1-1.842-.171 1.16 1.16 0 0 1-.3-.236c-.391-.45-.095-1 .688-1.233.271-.078.553-.112.835-.1.239.009.475.053.7.13.107.037.21.084.307.14Z"
            fill="#FFBF00"
        />
        <path
            d="m658.448 426.139-2.2 2.811a2.46 2.46 0 0 0-.7-.13l2.246-2.876c.209.092.429.158.654.195Z"
            fill="#02567D"
        />
        <path
            d="M660.451 424.188c.141.079.267.181.374.3.511.579.119 1.284-.873 1.574a3.38 3.38 0 0 1-1.5.078 2.748 2.748 0 0 1-.656-.2 1.354 1.354 0 0 1-.188-.1 1.496 1.496 0 0 1-.373-.3.795.795 0 0 1-.22-.6.808.808 0 0 1 .177-.416c.244-.276.566-.471.923-.558a3.328 3.328 0 0 1 1.935.036c.14.049.274.111.401.186Z"
            fill="#E54332"
        />
        <path
            d="m663.006 422.019-2.96 1.989a3.132 3.132 0 0 0-.748-.15l3.173-2.134c.067.046.133.09.2.132.108.062.22.116.335.163ZM663.253 419.348a3.136 3.136 0 0 0-.585.256l-2.3-2.2c.109-.019.217-.044.323-.075.111-.032.22-.072.325-.119l2.237 2.138Z"
            fill="#02567D"
        />
        <path
            d="M661.186 415.454c.14.079.266.18.373.3.458.507.2 1.119-.547 1.455a2.34 2.34 0 0 1-.325.119 2.966 2.966 0 0 1-.323.075 3.144 3.144 0 0 1-2.021-.293 1.498 1.498 0 0 1-.377-.3c-.511-.571-.119-1.276.88-1.57a3.202 3.202 0 0 1 2.34.214Z"
            fill="#134663"
        />
        <path
            d="M666.546 419.605c.192.108.365.246.512.409.691.778.159 1.739-1.2 2.137-.94.267-1.942.22-2.854-.132a2.745 2.745 0 0 1-.331-.163 2.164 2.164 0 0 1-.2-.132c-.11-.08-.21-.172-.3-.274-.563-.63-.322-1.373.5-1.846.186-.105.382-.191.585-.256l.111-.035a4.328 4.328 0 0 1 3.177.292Z"
            fill="#E54332"
        />
        <path
            d="M638.166 427.877c.104.059.198.134.279.221.042.047.078.1.107.156a.532.532 0 0 1 .056.318.81.81 0 0 1-.438.549c-.122.07-.252.126-.387.166l-.082.022a2.534 2.534 0 0 1-1.341-.039 1.692 1.692 0 0 1-.428-.202 1.063 1.063 0 0 1-.2-.172c-.341-.381-.143-.844.426-1.1a2.22 2.22 0 0 1 .495-.146 2.373 2.373 0 0 1 1.513.227Z"
            fill="#FFBF00"
        />
        <path
            d="M642.713 427.876c.008.114.05.222.119.313l-4.224.383a.532.532 0 0 0-.056-.318l4.161-.378Z"
            fill="#02567D"
        />
        <path
            d="M645.308 427.228c.106.06.202.136.284.226.379.433.084.963-.663 1.182a2.54 2.54 0 0 1-1.284.027 1.82 1.82 0 0 1-.483-.187 1.075 1.075 0 0 1-.33-.287.586.586 0 0 1-.119-.313c-.018-.331.286-.653.83-.813a2.574 2.574 0 0 1 1.214-.039c.193.039.379.108.551.204Z"
            fill="#E54332"
        />
        <path
            d="m643.006 417.543.159.306-3.33.587a.53.53 0 0 0-.059-.327l3.23-.566Z"
            fill="#02567D"
        />
        <path
            d="M639.392 417.737c.106.059.202.136.283.226a.804.804 0 0 1 .1.146c.054.1.075.215.059.327-.043.294-.339.568-.827.712a2.54 2.54 0 0 1-.83.09 2.125 2.125 0 0 1-.932-.253 1.128 1.128 0 0 1-.281-.224c-.385-.437-.09-.967.657-1.186a2.408 2.408 0 0 1 1.771.162Z"
            fill="#E54332"
        />
        <path
            d="m638.729 419.21.47 1.733a2.567 2.567 0 0 0-.547.042l-.474-1.747c.184.011.369.001.551-.028Z"
            fill="#02567D"
        />
        <path
            d="M640.195 421.199c.105.059.2.135.281.225a.56.56 0 0 1 .05.747 1.044 1.044 0 0 1-.308.269c-.126.073-.26.13-.4.169a2.476 2.476 0 0 1-1.614-.083 1.44 1.44 0 0 1-.372-.235 1.464 1.464 0 0 1-.068-.069c-.379-.433-.084-.964.668-1.186a2.634 2.634 0 0 1 .765-.093c.348.005.69.092.998.256ZM646.151 423.318c.078.044.15.101.211.167.283.319.06.716-.5.876a1.876 1.876 0 0 1-.955.018 1.357 1.357 0 0 1-.353-.138.855.855 0 0 1-.211-.167.42.42 0 0 1-.111-.206.425.425 0 0 1 .019-.234.62.62 0 0 1 .25-.286 1.25 1.25 0 0 1 .338-.15c.436-.13.906-.087 1.312.12Z"
            fill="#FFBF00"
        />
        <path
            d="m640.525 422.171 3.98 1.177a.631.631 0 0 0-.25.286l-4.037-1.194c.119-.068.224-.159.307-.269ZM644.757 427.024a2.574 2.574 0 0 0-.546-.055l.7-2.59c.179.044.364.061.549.051l-.703 2.594Z"
            fill="#02567D"
        />
        <path
            d="M635.5 423.882c.059.035.117.072.173.113.095.067.182.145.26.232.546.616.193 1.359-.772 1.73a3.66 3.66 0 0 1-.495.145 3.649 3.649 0 0 1-2.449-.311 1.747 1.747 0 0 1-.431-.343.956.956 0 0 1-.251-.521.777.777 0 0 1 .027-.318 1.7 1.7 0 0 1 1.237-.978 3.782 3.782 0 0 1 2.479.139c.076.033.15.071.222.112Z"
            fill="#134663"
        />
        <path
            d="M637.833 422.291c.066.06.138.112.215.156.051.029.104.056.157.079l-2.533 1.469a1.836 1.836 0 0 0-.173-.113 2.561 2.561 0 0 0-.222-.112l2.556-1.479ZM636.397 427.714c-.08.024-.158.052-.234.086l-.707-.8-.791-.9a3.55 3.55 0 0 0 .496-.145l1.495 1.7a2.553 2.553 0 0 0-.259.059Z"
            fill="#02567D"
        />
        <path
            d="M643.531 417.354a.73.73 0 0 1 .187.15c.255.283.06.632-.434.775-.383.116-.795.08-1.152-.1a.714.714 0 0 1-.187-.15c-.254-.283-.06-.631.434-.775a1.566 1.566 0 0 1 1.152.1ZM645.008 414.254c.07.039.132.088.185.147.047.05.081.111.1.176a.368.368 0 0 1-.07.314.872.872 0 0 1-.468.288 1.569 1.569 0 0 1-1.153-.106.735.735 0 0 1-.185-.148c-.252-.286-.054-.633.434-.775a1.57 1.57 0 0 1 1.157.104ZM654.399 418.141c.104.058.198.133.278.221a.72.72 0 0 1 .121.188.518.518 0 0 1 .033.32 1.036 1.036 0 0 1-.8.662 2.374 2.374 0 0 1-1.747-.159 1.119 1.119 0 0 1-.28-.223c-.332-.379-.14-.834.424-1.084a1.94 1.94 0 0 1 .488-.144 2.335 2.335 0 0 1 1.483.219Z"
            fill="#E54332"
        />
        <path
            d="M650.84 415.916c.079-.023.156-.051.231-.084l1.842 2.09a1.94 1.94 0 0 0-.488.144l-1.842-2.091c.087-.014.173-.034.257-.059Z"
            fill="#02567D"
        />
        <path
            d="M651.213 414.526c.105.059.199.135.28.223.332.38.14.835-.422 1.083a2.021 2.021 0 0 1-.488.143 2.33 2.33 0 0 1-1.488-.217 1.075 1.075 0 0 1-.277-.221.603.603 0 0 1-.167-.4.574.574 0 0 1 .1-.31 1.28 1.28 0 0 1 .721-.463 2.499 2.499 0 0 1 1.262-.024c.16.038.314.096.458.174l.021.012Z"
            fill="#FFBF00"
        />
        <path
            d="M648.751 414.827a.566.566 0 0 0-.1.31l-3.43-.248a.368.368 0 0 0 .07-.314l3.46.252ZM652.72 412.566c.153.071.314.123.479.154l-2.008 1.794a1.866 1.866 0 0 0-.458-.174l1.987-1.774Z"
            fill="#02567D"
        />
        <path
            d="M654.733 411.278c.104.058.198.133.278.222a.716.716 0 0 1 .136.224c.036.101.04.211.011.314a1.067 1.067 0 0 1-.795.632 2.528 2.528 0 0 1-1.163.05 2 2 0 0 1-.585-.21 1.08 1.08 0 0 1-.28-.223c-.374-.427-.083-.951.659-1.17a2.379 2.379 0 0 1 1.739.161Z"
            fill="#E54332"
        />
        <path d="M932.523 435.409v-60h-2v60h2Z" fill="#F72585" />
        <path d="M932.523 459.409v-60h-2v60h2Z" fill="#7209B7" />
        <path d="M932.523 610.409v-58h-2v58h2Z" fill="#3A0CA3" />
        <path d="M932.523 726.409v-60h-2v60h2Z" fill="#4895EF" />
        <path d="M932.523 459.409v-60h-2v60h2Z" fill="#B5179E" />
        <path d="M932.523 576.409v-60h-2v60h2Z" fill="#480CA8" />
        <path d="M932.523 727.409v-81h-2v81h2Z" fill="#4361EE" />
        <path d="M932.523 518.409v-59h-2v59h2Z" fill="#560BAD" />
        <path d="M932.523 646.409v-60h-2v60h2Z" fill="#3F37C9" />
        <path d="M932.523 751.409v-58h-2v58h2Z" fill="#4CC9F0" />
        <path
            d="M932.91 375.324c58.705 0 106.29-27.43 106.29-61.268 0-33.837-47.585-61.268-106.29-61.268-58.704 0-106.294 27.431-106.294 61.268 0 33.838 47.59 61.268 106.294 61.268Z"
            fill="#282739"
        />
        <path
            d="M932.91 374.824c58.429 0 105.79-27.206 105.79-60.768 0-33.561-47.361-60.768-105.79-60.768-58.428 0-105.794 27.207-105.794 60.768 0 33.562 47.366 60.768 105.794 60.768Z"
            stroke="#DEDDE2"
        />
        <path
            d="m937.221 231.556-11.278-6.554-23.625 13.64.143 50.523 11.278 6.554 23.625-13.643-.143-50.52Z"
            fill="#02314B"
        />
        <path
            d="m913.739 295.72-11.278-6.554-.143-50.523 11.278 6.554.143 50.523Z"
            fill="#1F0952"
        />
        <path
            d="m913.596 245.196-11.278-6.554 23.625-13.64 11.278 6.554-23.625 13.64Z"
            fill="#560BAD"
        />
        <path
            d="m937.222 231.556.143 50.523-23.625 13.64-.143-50.523 23.625-13.64Z"
            fill="#331083"
        />
        <path
            d="m931.773 240.904.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM931.801 250.223l.008 2.827-2.46 1.42-.007-2.822 2.459-1.425ZM931.79 246.908l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42ZM934.65 245.257l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42ZM934.678 254.575l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.992 270.504l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.982 267.196l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM934.716 267.201l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM934.703 263.893l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.272 273.807l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM931.853 268.852l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM931.846 265.545l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.096 259.53l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M917.806 267.739c.627-.362 1.142-.075 1.145.646a2.513 2.513 0 0 1-1.137 1.969c-.627.362-1.142.075-1.145-.652a2.497 2.497 0 0 1 1.137-1.963Z"
            fill="#4CC9F0"
        />
        <path
            d="m935.957 271.198.025 8.735-20.912 12.074-.025-8.735 20.912-12.074Z"
            fill="#633AC1"
        />
        <path
            d="M917.822 273.504c.627-.362 1.142-.068 1.145.651a2.516 2.516 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.502 2.502 0 0 1 1.137-1.968Z"
            fill="#F72585"
        />
        <path
            d="m915.018 274.09 20.912-12.074.024 8.317-20.913 12.074-.023-8.317Zm11.113-2.416-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-2.861 1.652-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001Zm8.582-4.955-.009-2.827-2.46 1.421.009 2.827 2.46-1.421Zm2.86-1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-5.721 3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm5.731 0-.009-2.827-2.46 1.421.009 2.827 2.46-1.421Zm-8.582 4.955-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001Zm5.721-3.3-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001Zm-8.581 4.954-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm5.721-3.3-.009-2.828-2.459 1.421.008 2.828 2.46-1.421Zm-11.161 6.34a2.507 2.507 0 0 0 1.137-1.969c0-.72-.518-1.014-1.145-.651a2.518 2.518 0 0 0-1.137 1.968c0 .721.518 1.014 1.145.652Zm-.01-3.548a2.507 2.507 0 0 0 1.137-1.969c0-.72-.518-1.013-1.145-.651a2.518 2.518 0 0 0-1.137 1.968c0 .721.518 1.014 1.145.652Z"
            fill="#633AC1"
        />
        <path
            d="M917.795 264.191c.627-.362 1.142-.075 1.145.646a2.5 2.5 0 0 1-1.137 1.969c-.627.362-1.142.075-1.145-.652a2.51 2.51 0 0 1 1.137-1.963Z"
            fill="#F72585"
        />
        <path
            d="m914.992 264.772 20.912-12.074.024 8.324-20.912 12.074-.024-8.324Zm11.122.892-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001Zm-2.86 1.651-.008-2.828-2.46 1.421.008 2.828 2.46-1.421Zm11.442-6.606-.009-2.827-2.459 1.421.008 2.827 2.46-1.421Zm-2.861 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-2.86 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-2.87-1.656-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-2.861 1.651-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm8.582-4.954-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001Zm2.86-1.651-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001Zm-5.721 3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-11.161 6.1a2.494 2.494 0 0 0 1.137-1.969c0-.721-.518-1.008-1.145-.646a2.51 2.51 0 0 0-1.137 1.962c0 .727.518 1.014 1.145.652v.001Zm.01 3.548a2.494 2.494 0 0 0 1.137-1.969c0-.721-.518-1.008-1.145-.646a2.51 2.51 0 0 0-1.137 1.962c0 .727.518 1.014 1.145.652v.001Z"
            fill="#633AC1"
        />
        <path
            d="m934.687 257.883.008 2.827-2.46 1.421-.008-2.827 2.46-1.421ZM931.826 259.534l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.966 261.185l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM931.816 256.227l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.262 270.499l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M917.831 277.056c.627-.362 1.142-.068 1.145.651a2.502 2.502 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.515 2.515 0 0 1 1.137-1.968Z"
            fill="#4CC9F0"
        />
        <path
            d="m926.078 253.525.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.21 251.863l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M917.779 258.421c.627-.362 1.142-.075 1.145.652a2.504 2.504 0 0 1-1.137 1.962c-.627.362-1.142.075-1.145-.646a2.513 2.513 0 0 1 1.137-1.968Z"
            fill="#4CC9F0"
        />
        <path
            d="m914.965 255.461 20.913-12.074.023 8.317-20.911 12.073-.025-8.316Zm11.113-2.416-.008-2.833-2.46 1.419.008 2.834 2.46-1.421v.001Zm-2.861 1.651-.008-2.833-2.46 1.421.009 2.833 2.459-1.421Zm8.582-4.954-.009-2.837-2.46 1.421.008 2.834 2.46-1.421.001.003Zm2.86-1.651-.008-2.834-2.46 1.421.008 2.833 2.46-1.419v-.001Zm-5.721 3.3-.008-2.833-2.46 1.419.008 2.834 2.46-1.421v.001Zm5.731 0-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-8.582 4.955-.008-2.828-2.46 1.421.008 2.827 2.46-1.419v-.001Zm5.721-3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-8.581 4.955-.008-2.828-2.46 1.421.008 2.828 2.46-1.421Zm5.721-3.3-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-11.158 6.334a2.497 2.497 0 0 0 1.137-1.962c0-.727-.518-1.014-1.145-.652a2.516 2.516 0 0 0-1.137 1.969c0 .721.518 1.008 1.145.646v-.001Zm-.01-3.548a2.5 2.5 0 0 0 1.137-1.963c0-.727-.518-1.014-1.145-.652a2.512 2.512 0 0 0-1.137 1.969c0 .721.518 1.008 1.145.646Z"
            fill="#633AC1"
        />
        <path
            d="m934.659 248.571.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.106 262.834l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.956 257.878l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.939 251.874l.009 2.827-2.461 1.42-.008-2.827 2.46-1.42ZM934.634 239.253l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.931 248.56l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42ZM923.219 255.177l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.069 250.211l.008 2.834-2.46 1.42-.008-2.834 2.46-1.42ZM928.912 242.556l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM931.764 237.597l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.054 244.207l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM928.904 239.248l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M917.769 254.871c.627-.362 1.142-.075 1.145.652a2.502 2.502 0 0 1-1.137 1.963c-.627.362-1.142.075-1.145-.646a2.508 2.508 0 0 1 1.137-1.969Z"
            fill="#F72585"
        />
        <path
            d="m923.192 245.859.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.042 240.9l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.184 242.551l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="M917.752 249.103c.627-.362 1.142-.075 1.145.652a2.514 2.514 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.503 2.503 0 0 1 1.137-1.969Z"
            fill="#4CC9F0"
        />
        <path
            d="M917.744 245.555c.627-.362 1.142-.075 1.145.652a2.502 2.502 0 0 1-1.137 1.969c-.627.362-1.142.068-1.145-.652a2.51 2.51 0 0 1 1.137-1.969Z"
            fill="#F72585"
        />
        <path
            d="m914.938 246.142 20.913-12.073.023 8.316-20.912 12.074-.024-8.317Zm16.834-5.719-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-8.572 8.262-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-.009-3.307-.009-2.827-2.46 1.421.009 2.827 2.46-1.421Zm2.87 1.656-.009-2.827-2.465 1.422.009 2.827 2.46-1.421.005-.001Zm-.01-3.307-.008-2.827-2.46 1.419.008 2.828 2.46-1.421v.001Zm5.73 0-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm2.861-1.651-.008-2.828-2.46 1.421.008 2.828 2.46-1.421Zm-.01-3.308-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-5.711 6.61-.008-2.827-2.46 1.421.008 2.827 2.46-1.421Zm-.01-3.307-.008-2.828-2.46 1.421.009 2.828 2.459-1.421Zm-11.151 9.648a2.51 2.51 0 0 0 1.137-1.969c0-.727-.518-1.014-1.145-.652a2.513 2.513 0 0 0-1.137 1.969c0 .721.518 1.014 1.145.652Zm-.01-3.548a2.519 2.519 0 0 0 1.137-1.969c0-.727-.518-1.014-1.145-.652a2.51 2.51 0 0 0-1.137 1.969c0 .721.518 1.014 1.145.652Z"
            fill="#633AC1"
        />
        <path
            d="m934.625 235.946.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.244 264.489l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM923.236 261.178l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.132 272.155l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42ZM926.122 268.848l.008 2.827-2.46 1.42-.008-2.827 2.46-1.42Z"
            fill="#2D1071"
        />
        <path
            d="m975.294 304.613-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 297.356c6.9 3.981 6.926 10.437.081 14.415-6.845 3.978-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.981 24.88-.003Z"
            fill="#331083"
        />
        <path
            d="m975.294 296.801-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 289.544c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.41s17.99-3.98 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m975.294 288.989-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.63-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 281.732c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.979 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m975.294 281.177-.017 6.3c-.007 2.593-1.711 5.182-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 273.919c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.41s17.99-3.982 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m975.294 273.363-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 266.107c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.431-.075-14.412 6.85-3.981 17.99-3.979 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m975.294 265.552-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M970.101 258.294c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.98 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m968.728 312.902-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m968.62 274.672-1.337-.777 25.071-14.475 1.337.777-25.071 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m993.691 260.197.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m971.573 314.799-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m971.465 276.569-1.337-.777 25.071-14.475 1.337.777-25.071 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m996.536 262.094.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m974.524 317.142-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m974.416 278.912-1.337-.777 25.071-14.475 1.337.777-25.071 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m999.487 264.437.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m997.959 285.093.007 2.3-21.895 12.636-.007-2.3 21.895-12.636ZM997.927 275.303l.006 2.3-21.892 12.639-.007-2.3 21.893-12.639Z"
            fill="#9CB5CC"
        />
        <path
            d="m990.822 274.498.007 2.3-14.8 8.545-.006-2.3 14.799-8.545Z"
            fill="#FA7564"
        />
        <path
            d="m997.943 280.2.006 2.3-21.893 12.638-.006-2.3 21.893-12.638ZM997.984 294.891l.006 2.3-21.892 12.639-.006-2.3 21.892-12.639ZM997.969 289.992l.007 2.3-21.892 12.639-.007-2.3 21.892-12.639Z"
            fill="#9CB5CC"
        />
        <path
            d="m981.501 340.816-.674-.3-.071-.034 1.811 1.046.071.034.674.3c.015 0 .029.004.042.011l-1.81-1.046a.092.092 0 0 0-.043-.011ZM979.508 345.904a.134.134 0 0 0-.058-.085l-1.811-1.046a.134.134 0 0 1 .058.085l.376.732c.002.016.007.03.015.044.009.013.02.024.033.032l1.811 1.046a.1.1 0 0 1-.033-.032.098.098 0 0 1-.016-.044l-.375-.732Z"
            fill="#331083"
        />
        <path
            d="M981.729 337.223a.115.115 0 0 0-.037-.012.133.133 0 0 0-.04.003.198.198 0 0 0-.057.022.327.327 0 0 0-.048.035l-.685.446.373-.709a.485.485 0 0 1 .066-.112.403.403 0 0 1 .1-.084.242.242 0 0 1 .058-.023.148.148 0 0 1 .042 0l.782.087a.142.142 0 0 1 .035.011l-1.811-1.046a.135.135 0 0 0-.034-.011l-.783-.087a.14.14 0 0 0-.041 0 .347.347 0 0 0-.158.107.489.489 0 0 0-.067.112l-.59 1.123-.064.111-1.193-.689a.108.108 0 0 0-.077-.01.211.211 0 0 0-.054.022.327.327 0 0 0-.048.035l-.882.757a.511.511 0 0 0-.045.048.377.377 0 0 0-.089.3l.06 1v.107a6.476 6.476 0 0 0-.542.727.378.378 0 0 1-.09.074.21.21 0 0 1-.068.027.162.162 0 0 1-.044 0l-.842.111a.193.193 0 0 0-.034 0 .244.244 0 0 0-.063.025.386.386 0 0 0-.168.199l-.464 1.169c-.046.113-.032.214.028.249l.764.441c-.053.234-.09.471-.111.709a.523.523 0 0 1-.161.242l-.82.9a.425.425 0 0 0-.123.186.374.374 0 0 0-.012.156l.218.893a.11.11 0 0 0 .05.069l1.3.752-.1.38c-.046.113-.028.216.032.251l1.811 1.046c-.061-.035-.078-.138-.032-.251l.316-1.153a.328.328 0 0 0 .015-.248 1.617 1.617 0 0 1-.358-.415l-1.225-.708.741-.817a.518.518 0 0 0 .161-.243c.023-.272.065-.543.127-.81l-.826-.477c0-.038.006-.075.019-.111l.464-1.169a.477.477 0 0 1 .068-.115.367.367 0 0 1 .1-.084.244.244 0 0 1 .063-.025.193.193 0 0 1 .034 0l.842-.111c.015.002.03.002.044 0a.21.21 0 0 0 .068-.027.355.355 0 0 0 .089-.075 8.358 8.358 0 0 1 .543-.727v-.107l-.06-1a.377.377 0 0 1 .134-.348l.559-.479.986.569a.116.116 0 0 0 .075.014 2.99 2.99 0 0 1 .622-.214h.011l.065-.113.068-.13 1.654.955.092-.054.9-.585a.235.235 0 0 1 .105-.058.108.108 0 0 1 .077.01l-1.815-1.043Z"
            fill="#331083"
        />
        <path
            d="m980.581 340.539-1.811-1.046a.774.774 0 0 1 .342.5 2.569 2.569 0 0 1-.62 2.034c-.099.12-.207.231-.323.333a2.011 2.011 0 0 1-.316.228 1.313 1.313 0 0 1-.393.158.74.74 0 0 1-.534-.066l1.81 1.045a.737.737 0 0 0 .535.067c.138-.032.271-.085.393-.158a2.07 2.07 0 0 0 .315-.228c.117-.101.225-.213.323-.334a2.552 2.552 0 0 0 .621-2.033.774.774 0 0 0-.342-.5Z"
            fill="#331083"
        />
        <path
            d="M983.812 339.23a.401.401 0 0 1-.141.346l-.82.9a.56.56 0 0 0-.152.245 4.766 4.766 0 0 1-.132.807l.071.034.674.3c.093 0 .121.125.067.257l-.464 1.169a.411.411 0 0 1-.161.2.161.161 0 0 1-.1.025l-.841.118a.204.204 0 0 0-.113.03.421.421 0 0 0-.1.078 8.22 8.22 0 0 1-.537.721v.1l.06 1a.397.397 0 0 1-.14.345l-.877.761a.202.202 0 0 1-.042.03c-.088.051-.168.032-.188-.06l-.375-.732a.128.128 0 0 0-.014-.043.126.126 0 0 0-.072-.054.12.12 0 0 0-.046-.003c-.204.097-.418.17-.639.22l-.059.11-.6 1.12a.4.4 0 0 1-.16.2.169.169 0 0 1-.1.026l-.777-.09c-.088-.012-.121-.131-.067-.263l.316-1.153a.328.328 0 0 0 .015-.248 1.617 1.617 0 0 1-.358-.415l-.092.054-.9.585a.26.26 0 0 1-.046.034c-.083.048-.161.024-.184-.058l-.218-.893a.389.389 0 0 1 .134-.342l.821-.9a.506.506 0 0 0 .157-.243c.023-.272.065-.543.127-.81l-.066-.031-.679-.3c-.088-.012-.116-.128-.062-.26l.464-1.169a.423.423 0 0 1 .164-.2.188.188 0 0 1 .1-.029l.842-.111a.191.191 0 0 0 .112-.03.374.374 0 0 0 .089-.075c.166-.252.347-.494.543-.724v-.107l-.06-1a.39.39 0 0 1 .134-.349l.882-.757a.327.327 0 0 1 .048-.035c.084-.049.158-.024.182.058l.37.736a.13.13 0 0 0 .049.078.128.128 0 0 0 .089.022 2.96 2.96 0 0 1 .633-.217l.065-.113.59-1.123a.413.413 0 0 1 .162-.2.161.161 0 0 1 .1-.025l.782.087c.088.012.116.128.062.266l-.316 1.153a.365.365 0 0 0-.015.248c.144.116.265.256.358.415l.092-.054.9-.585a.327.327 0 0 1 .048-.035c.086-.05.163-.026.182.059l.229.899Zm-3.833 4.178a2.69 2.69 0 0 0 .944-2.367c-.148-.6-.687-.751-1.275-.41a2.224 2.224 0 0 0-.306.221 2.73 2.73 0 0 0-.949 2.376c.151.6.684.749 1.271.408.112-.066.218-.142.315-.228Z"
            fill="#560BAD"
        />
        <path
            d="m986.294 326.72-.953-.422-.1-.049 1.811 1.046.1.049.954.422c.02.002.04.008.057.017l-1.811-1.046a.162.162 0 0 0-.058-.017ZM982.723 333.492a.194.194 0 0 0-.029-.068.205.205 0 0 0-.054-.052l-1.811-1.046a.191.191 0 0 1 .083.12l.525 1.035a.161.161 0 0 0 .073.105l1.811 1.046a.166.166 0 0 1-.073-.1l-.525-1.04ZM986.617 321.64a.159.159 0 0 0-.111-.014.309.309 0 0 0-.084.034.461.461 0 0 0-.062.044l-1.27.825-.131.083 1.811 1.041.131-.082 1.27-.826a.445.445 0 0 1 .061-.043.309.309 0 0 1 .084-.034.16.16 0 0 1 .112.014l-1.811-1.042ZM984.243 325.895l-1.811-1.042a1.081 1.081 0 0 1 .486.709 3.642 3.642 0 0 1-.881 2.878 3.71 3.71 0 0 1-.462.476c-.136.12-.284.227-.441.319a1.857 1.857 0 0 1-.555.223 1.052 1.052 0 0 1-.758-.094l1.811 1.046c.232.125.503.158.758.093.196-.044.383-.119.555-.222.157-.092.305-.199.441-.319a3.71 3.71 0 0 0 .462-.476 3.642 3.642 0 0 0 .881-2.878 1.087 1.087 0 0 0-.486-.713Z"
            fill="#4895EF"
        />
        <path
            d="m979.104 332.653-1.733-1 1.048-1.15a.762.762 0 0 0 .222-.35c.03-.385.09-.766.18-1.142l-1.172-.678a.438.438 0 0 1 .024-.16l.664-1.651a.661.661 0 0 1 .1-.167.487.487 0 0 1 .127-.112.27.27 0 0 1 .077-.031.167.167 0 0 1 .063 0l1.2-.173a.2.2 0 0 0 .069 0 .33.33 0 0 0 .1-.039.567.567 0 0 0 .124-.1c.201-.306.417-.602.649-.886l.111-.134v-.151l-.084-1.417a.52.52 0 0 1 .128-.422.712.712 0 0 1 .066-.069l.787-.679 1.391.8a.178.178 0 0 0 .109.02c.288-.132.59-.233.9-.3l.087-.157.839-1.589a.62.62 0 0 1 .1-.172.498.498 0 0 1 .129-.113.306.306 0 0 1 .084-.033.188.188 0 0 1 .058 0l1.1.129a.152.152 0 0 1 .051.016l-1.811-1.045a.134.134 0 0 0-.051-.017l-1.1-.129a.188.188 0 0 0-.058 0 .28.28 0 0 0-.084.034.482.482 0 0 0-.129.113.64.64 0 0 0-.1.171l-.839 1.589-.084.154-1.691-.977a.156.156 0 0 0-.11-.013.264.264 0 0 0-.082.032.505.505 0 0 0-.06.043l-1.247 1.077a.584.584 0 0 0-.194.49l.085 1.417v.151l-.111.134c-.232.285-.448.581-.649.887a.567.567 0 0 1-.124.1.306.306 0 0 1-.1.039.2.2 0 0 1-.069 0l-1.2.173a.222.222 0 0 0-.063 0 .27.27 0 0 0-.077.031.623.623 0 0 0-.226.28l-.664 1.65c-.063.165-.041.307.043.356l1.077.622c-.074.33-.125.664-.152 1a.762.762 0 0 1-.222.35l-1.158 1.27a.807.807 0 0 0-.064.067.523.523 0 0 0-.13.424l.313 1.253a.162.162 0 0 0 .024.061.147.147 0 0 0 .047.046l1.81 1.045a.152.152 0 0 1-.07-.106l-.313-1.253a.523.523 0 0 1 .13-.424.807.807 0 0 1 .064-.067l.084-.092c.125.195.278.37.454.52a.454.454 0 0 1-.02.345l-.445 1.631c-.065.163-.045.309.043.359l1.811 1.046c-.088-.051-.108-.2-.043-.359l.445-1.631a.454.454 0 0 0 .02-.345 2.401 2.401 0 0 1-.508-.592Z"
            fill="#4895EF"
        />
        <path
            d="M988.812 324.045a.562.562 0 0 1-.194.49l-1.163 1.274a.743.743 0 0 0-.217.346 7.186 7.186 0 0 1-.185 1.14l.1.049.954.422c.132.011.171.178.1.366l-.658 1.654a.575.575 0 0 1-.229.279.226.226 0 0 1-.141.036l-1.191.17a.288.288 0 0 0-.167.043.556.556 0 0 0-.122.1 10.03 10.03 0 0 1-.766 1.024l.007.147.084 1.417a.548.548 0 0 1-.194.484l-1.247 1.077a.38.38 0 0 1-.069.05c-.12.07-.226.038-.259-.086l-.525-1.035a.166.166 0 0 0-.067-.109.174.174 0 0 0-.125-.031c-.288.133-.59.233-.9.3l-.093.161-.838 1.589a.595.595 0 0 1-.23.284.227.227 0 0 1-.135.034l-1.105-.125c-.126-.022-.165-.188-.09-.376l.445-1.631a.454.454 0 0 0 .02-.345 2.438 2.438 0 0 1-.506-.593l-.126.073-1.275.829a.397.397 0 0 1-.067.049c-.118.069-.228.038-.256-.088l-.313-1.253a.567.567 0 0 1 .194-.491l1.158-1.27a.768.768 0 0 0 .222-.35c.03-.385.09-.766.18-1.142l-.093-.047-.96-.418c-.126-.015-.17-.178-.1-.373l.664-1.65a.574.574 0 0 1 .225-.28.217.217 0 0 1 .14-.033l1.2-.173a.26.26 0 0 0 .165-.042.545.545 0 0 0 .124-.1c.233-.355.487-.695.76-1.02v-.151l-.084-1.417a.549.549 0 0 1 .194-.49l1.247-1.077a.505.505 0 0 1 .06-.043c.121-.07.234-.041.262.088l.526 1.036a.169.169 0 0 0 .192.14c.288-.133.59-.233.9-.3l.086-.157.839-1.589a.577.577 0 0 1 .228-.285.254.254 0 0 1 .142-.037l1.1.129c.126.015.171.184.1.372l-.45 1.634a.454.454 0 0 0-.02.345c.201.168.372.368.506.593l.131-.082 1.27-.826a.38.38 0 0 1 .062-.043c.123-.072.232-.042.266.079l.307 1.255Zm-5.425 5.914a3.827 3.827 0 0 0 1.343-3.354c-.214-.849-.969-1.061-1.8-.579-.158.093-.307.2-.445.321a3.818 3.818 0 0 0-1.338 3.351c.209.848.969 1.061 1.8.58.157-.092.304-.199.441-.319h-.001Z"
            fill="#4CC9F0"
        />
        <path
            d="m998.818 334.553 1.812 1.046a.21.21 0 0 1 .03.015l-1.807-1.046a.184.184 0 0 0-.035-.015Z"
            fill="#D43E3E"
        />
        <path
            d="M999.843 327.398a.214.214 0 0 0-.155-.017.538.538 0 0 0-.16.067l-1.775.939a.488.488 0 0 1-.133.056l1.811 1.046a.463.463 0 0 0 .129-.056l1.78-.939c.05-.031.1-.053.16-.067.05-.013.1-.008.15.016l-1.807-1.045ZM993.028 342.624a.301.301 0 0 0-.038-.12.302.302 0 0 0-.087-.091l-1.811-1.045a.28.28 0 0 1 .125.21l.545 1.584c.002.035.011.07.029.1a.216.216 0 0 0 .071.076l1.811 1.046a.207.207 0 0 1-.071-.076.207.207 0 0 1-.029-.1l-.545-1.584ZM995.743 332.017l-1.811-1.046a1.599 1.599 0 0 1 .713 1.24 5.205 5.205 0 0 1-1.254 3.642c-.257.32-.554.605-.882.85a3.72 3.72 0 0 1-.338.223c-.235.14-.491.241-.757.3a1.424 1.424 0 0 1-1.026-.127l1.811 1.046c.314.169.68.215 1.026.127.266-.059.522-.16.757-.3a3.72 3.72 0 0 0 .338-.223 4.93 4.93 0 0 0 .882-.85 5.2 5.2 0 0 0 1.254-3.638 1.6 1.6 0 0 0-.713-1.244ZM988.511 340.672l-1.81-1.046c.138.345.33.665.568.948a.709.709 0 0 1-.063.483l-.78 2.235c-.109.23-.1.457.035.532l1.811 1.045c-.13-.074-.144-.3-.036-.531l.781-2.235a.709.709 0 0 0 .063-.483 3.542 3.542 0 0 1-.569-.948ZM993.329 326.732a.216.216 0 0 1-.1-.03l1.81 1.046c.03.017.064.028.1.03.184-.062.372-.114.563-.155.205-.044.413-.073.623-.087l.135-.211 1.274-2.086a.906.906 0 0 1 .111-.177.67.67 0 0 1 .178-.157.384.384 0 0 1 .111-.044.211.211 0 0 1 .106 0l1.392.419c.014.004.029.01.043.017l-1.814-1.044a.256.256 0 0 0-.043-.017l-1.392-.419a.211.211 0 0 0-.106 0 .39.39 0 0 0-.11.044.658.658 0 0 0-.179.157.906.906 0 0 0-.111.177l-1.274 2.087-.135.21c-.21.014-.418.043-.623.087a5.07 5.07 0 0 0-.559.153Z"
            fill="#B5179E"
        />
        <path
            d="M990.61 331.387a.665.665 0 0 0 .125-.093 12.688 12.688 0 0 1 1.108-1.299.534.534 0 0 0 .01-.207l.071-2.036a.762.762 0 0 1 .183-.531.747.747 0 0 1 .125-.12l1.726-1.267c.017-.013.035-.024.051-.034a.387.387 0 0 1 .112-.045.203.203 0 0 1 .145.018l-1.81-1.046a.205.205 0 0 0-.146-.018.381.381 0 0 0-.111.045.655.655 0 0 0-.052.034l-1.726 1.265a.705.705 0 0 0-.124.12.759.759 0 0 0-.184.531l-.071 2.036c.01.069.007.14-.01.207a13.282 13.282 0 0 0-1.108 1.299.665.665 0 0 1-.125.093.415.415 0 0 1-.131.053.268.268 0 0 1-.132 0l-1.542-.01a.244.244 0 0 0-.114 0 .411.411 0 0 0-.111.045.668.668 0 0 0-.176.155.87.87 0 0 0-.111.176l-1.049 2.207c-.113.239-.095.464.031.536l.1.055 1.117.758.115.084a11.51 11.51 0 0 0-.38 1.586.966.966 0 0 1-.32.45l-1.643 1.565a.782.782 0 0 0-.124.12.768.768 0 0 0-.184.531l.24 1.856a.227.227 0 0 0 .029.099c.018.03.042.055.071.074l1.811 1.046a.216.216 0 0 1-.07-.074.216.216 0 0 1-.03-.099l-.24-1.856a.768.768 0 0 1 .184-.531.705.705 0 0 1 .124-.12l1.643-1.565a.977.977 0 0 0 .32-.45 11.51 11.51 0 0 1 .38-1.586l-.115-.084-1.175-.8-.05-.029c-.112-.08-.128-.293-.019-.523l1.049-2.208a.936.936 0 0 1 .11-.175.657.657 0 0 1 .177-.155.411.411 0 0 1 .111-.045.22.22 0 0 1 .114 0l1.542.01a.268.268 0 0 0 .132 0 .407.407 0 0 0 .127-.048Z"
            fill="#B5179E"
        />
        <path
            d="M1001.99 330.47c0 .125-.02.25-.08.363a.74.74 0 0 1-.23.288l-1.64 1.571a.938.938 0 0 0-.321.444 11.227 11.227 0 0 1-.38 1.586l.116.09 1.175.791c.16.052.19.29.07.551l-1.051 2.208a.762.762 0 0 1-.287.331.289.289 0 0 1-.225.042l-1.542-.01a.328.328 0 0 0-.261.05.607.607 0 0 0-.125.093c-.339.459-.709.894-1.11 1.3a.582.582 0 0 0-.01.208l-.07 2.036a.78.78 0 0 1-.309.651l-1.725 1.273c-.231.138-.386.072-.412-.126l-.545-1.584a.25.25 0 0 0-.224-.241 4.818 4.818 0 0 1-1.186.248l-.136.205-1.273 2.087a.744.744 0 0 1-.287.333.279.279 0 0 1-.22.043l-1.392-.413c-.164-.049-.193-.3-.074-.548l.781-2.235a.709.709 0 0 0 .063-.483 3.542 3.542 0 0 1-.569-.948.589.589 0 0 0-.132.056l-1.771.943c-.231.138-.39.075-.416-.123l-.24-1.856a.797.797 0 0 1 .309-.651l1.642-1.565a.971.971 0 0 0 .32-.45 11.51 11.51 0 0 1 .38-1.586l-.114-.084-1.176-.8c-.159-.046-.193-.291-.069-.552l1.049-2.208a.778.778 0 0 1 .287-.33.288.288 0 0 1 .225-.042l1.542.01a.333.333 0 0 0 .263-.05.665.665 0 0 0 .125-.093c.342-.456.712-.89 1.108-1.3a.534.534 0 0 0 .01-.207l.072-2.036a.78.78 0 0 1 .307-.651l1.727-1.267a.897.897 0 0 1 .05-.034c.181-.1.334-.044.36.154l.545 1.584a.247.247 0 0 0 .226.24 4.648 4.648 0 0 1 1.186-.242l.134-.211 1.275-2.086a.768.768 0 0 1 .289-.334.282.282 0 0 1 .216-.042l1.392.419c.164.043.193.29.074.542l-.781 2.234a.73.73 0 0 0-.063.484c.239.284.431.603.569.947a.49.49 0 0 0 .129-.054l1.78-.939c.22-.136.38-.078.41.12l.24 1.856Zm-7.671 7.275a5.407 5.407 0 0 0 2.136-4.488c-.178-1.351-1.258-1.782-2.494-1.063a3.932 3.932 0 0 0-.338.222 5.43 5.43 0 0 0-2.136 4.495c.178 1.345 1.258 1.775 2.494 1.057a3.46 3.46 0 0 0 .338-.223Z"
            fill="#F72585"
        />
        <path
            d="m939.154 343.994-30.965 17.994a5.852 5.852 0 0 1-5.3 0l-16.6-9.584 4.48-2.6v-1.219l3.073 1.764.439-.253.006-2.563-.008 3.07 6.7 3.843.423-.245v.492l8.844 5.077 4.1-2.392v-1.09l.938.538 1.375-.8 2.723-1.589 4.746-2.775v-1.374l1.187.683 4.094-2.4v-1.058l.914.527 4.094-2.4.008-3.069-4.286-2.463-.82.481v-.948l-4.288-2.465-.822.479v-.947l-4.286-2.463-.824.481v-.949l-4.286-2.463-.82.479v-.946l-4.286-2.463-.821.479v-.952l-4.292-2.459-.82.479v-.952l-4.291-2.462-.817.479v-.946l-4.293-2.466-.818.479v-.947l-4.293-2.463-4.091 2.393v1.062l-1.029-.59 2.399-1.377.007-3.069-4.285-2.463-4.1 2.393v1.059l-.913-.524-4.1 2.395v1.064l-.918-.529-4.1 2.395v1.065l-.918-.529-4.091 2.395v1.094l-.946-.543-4.092 2.392-.008 3.069 9.084 5.219.538-.314.006-2.448-.008 3.07 6.091 3.5-4.429 2.571v1.226l-20.3-11.72a1.872 1.872 0 0 1-1.1-1.545l-.009 3.068a1.877 1.877 0 0 0 1.1 1.547l53.835 31.08a5.852 5.852 0 0 0 5.3 0l30.964-18a1.853 1.853 0 0 0 1.085-1.524c0-1.022.003-2.045.008-3.069a1.856 1.856 0 0 1-1.088 1.528Z"
            fill="#331083"
        />
        <path
            d="m893.597 319.121-4.1 2.394-4.286-2.464 4.091-2.393 4.295 2.463ZM887.809 321.604l-4.094 2.4-10.561-6.065 4.1-2.394 10.555 6.059ZM898.704 322.055l-4.1 2.39-4.287-2.462 4.093-2.394 4.294 2.466ZM880.097 322.982l-4.1 2.394-7.863-4.516 4.1-2.394 7.863 4.516ZM903.808 324.984l-4.1 2.393-4.286-2.461 4.094-2.393 4.292 2.461ZM884.94 325.767l-4.1 2.393-4.289-2.46 4.1-2.394 4.289 2.461ZM897.782 327.334l-4.09 2.394-4.294-2.461 4.1-2.395 4.284 2.462ZM877.778 327.466l-4.1 2.392-10.557-6.062 4.096-2.394 10.561 6.064ZM908.915 327.915l-4.1 2.395-4.29-2.462 4.1-2.392 4.29 2.459ZM889.765 328.535l-4.1 2.394-4.289-2.46 4.1-2.393 4.289 2.459ZM871.266 329.562l-4.1 2.392-9.084-5.217 4.091-2.392 9.093 5.217ZM902.672 330.138l-4.1 2.394-4.286-2.463 4.1-2.393 4.286 2.462ZM882.658 330.266l-4.1 2.394-4.286-2.463 4.1-2.394 4.286 2.463ZM894.586 331.31l-4.1 2.393-4.286-2.464 4.1-2.393 4.286 2.464ZM887.43 333.007l-4.1 2.393-4.287-2.463 4.1-2.39 4.287 2.46ZM919.121 333.782l-4.091 2.392-4.294-2.462 4.1-2.393 4.285 2.463ZM878.505 333.717l-4.1 2.394-6.7-3.849 4.094-2.394 6.706 3.849ZM899.412 334.078l-4.1 2.393-4.286-2.463 4.1-2.393 4.286 2.463ZM892.253 335.777l-4.094 2.394-4.294-2.463 4.1-2.393 4.288 2.462ZM924.228 336.713l-4.1 2.393-4.285-2.461 4.1-2.394 4.285 2.462ZM904.238 336.848l-4.1 2.395-4.289-2.46 4.1-2.393 4.289 2.458ZM917.306 338.547l-4.091 2.393-4.291-2.461 4.1-2.394 4.282 2.462ZM897.024 338.518l-4.1 2.393-4.285-2.461 4.1-2.393 4.285 2.461ZM929.335 339.646l-4.1 2.393-4.289-2.466 4.1-2.392 4.289 2.465ZM934.438 342.569l-4.1 2.393-4.289-2.466 4.1-2.393 4.289 2.466ZM909.058 339.621l-4.094 2.4-4.289-2.466 4.1-2.393 4.283 2.459ZM922.188 341.35l-4.1 2.394-4.286-2.461 4.094-2.4 4.292 2.467ZM902.01 341.381l-4.1 2.393-4.289-2.464 4.1-2.393 4.289 2.464ZM913.881 342.392l-4.094 2.394-4.29-2.465 4.1-2.392 4.284 2.463ZM906.782 344.121l-4.1 2.393-4.286-2.464 4.094-2.39 4.292 2.461ZM918.713 345.163l-4.1 2.392-4.293-2.462 4.1-2.394 4.293 2.464ZM929.426 345.505l-4.1 2.4-6.644-3.816 4.1-2.392 6.644 3.808ZM911.602 346.891l-4.1 2.393-4.289-2.463 4.1-2.393 4.289 2.463ZM890.778 346.736l-6.073 3.53-15.346-8.861 6.075-3.528 15.344 8.859ZM905.09 348.991l-4.1 2.39-6.7-3.845 4.1-2.394 6.7 3.849Z"
            fill="#F8F9FC"
        />
        <path
            d="m924.142 348.589-4.747 2.773-2.724 1.591-1.375.8-7.233-4.156 4.1-2.393 2.221 1.278 4.747-2.773 5.011 2.88Z"
            fill="#F8F9FC"
        />
        <path
            d="M939.137 340.926c1.463.844 1.471 2.223.017 3.068l-30.965 17.994a5.855 5.855 0 0 1-5.3 0l-53.833-31.079c-1.462-.845-1.47-2.225-.016-3.072l30.964-17.992a5.853 5.853 0 0 1 5.3 0l53.833 31.081Zm-54.432 9.339 6.073-3.529-15.344-8.86-6.074 3.528 15.345 8.861Zm-9.688-13.8 18.837 10.82 4.1-2.393-18.846-10.82-4.092 2.393h.001Zm41.654 16.5 2.724-1.591 4.747-2.773-5.011-2.878-4.747 2.773-2.221-1.278-4.1 2.393 7.233 4.156 1.374-.8.001-.002Zm-28.863-31.354-10.556-6.064-4.1 2.395 10.561 6.065 4.093-2.4.002.004Zm-10.03 5.861-10.561-6.065-4.091 2.395 10.556 6.063 4.1-2.392-.004-.001Zm-19.692-.727 9.084 5.216 4.1-2.391-9.088-5.218-4.092 2.392-.004.001Zm43.334 24.887 8.84 5.079 4.094-2.391-8.843-5.082-4.092 2.394h.001Zm-21.322-28.64-7.864-4.516-4.1 2.394 7.863 4.516 4.1-2.395.001.001Zm-12.392 9.278 6.7 3.849 4.1-2.393-6.7-3.85-4.094 2.394h-.006Zm26.585 15.272 6.7 3.846 4.1-2.391-6.7-3.849-4.1 2.395v-.001Zm24.395-3.45 6.645 3.815 4.094-2.4-6.644-3.812-4.1 2.392.005.005Zm-8.36 1.002 4.293 2.461 4.1-2.391-4.293-2.465-4.1 2.395Zm-18.069-9.317-4.289-2.462-4.1 2.393 4.294 2.462 4.093-2.393h.002Zm16.662-7.862-4.293-2.462-4.1 2.391 4.289 2.462 4.1-2.395.004.004Zm-6.906 13.466-4.289-2.465-4.1 2.393 4.289 2.465 4.1-2.393Zm15.891-2.495-4.094 2.4 4.287 2.461 4.1-2.395-4.289-2.463-.004-.003Zm-24.3-19.766-4.3-2.467-4.091 2.393 4.286 2.463 4.1-2.393.005.004Zm-.1 5.751-4.1 2.395 4.294 2.461 4.091-2.393-4.286-2.462.001-.001Zm-10.839 5.395-4.288-2.462-4.1 2.393 4.286 2.463 4.1-2.395.002.001Zm30.362 5.818-4.1 2.395 4.292 2.461 4.092-2.392-4.287-2.463.003-.001Zm-4.88-2.8-4.1 2.392 4.291 2.462 4.1-2.393-4.289-2.461h-.002Zm-4.882-2.8-4.1 2.39 4.291 2.466 4.094-2.4-4.289-2.46.004.004Zm31.18 12.1-4.286-2.463-4.1 2.393 4.288 2.466 4.094-2.4.004.004Zm-5.1-2.93-4.288-2.465-4.1 2.392 4.289 2.466 4.1-2.393h-.001Zm-52.781-13.947 4.288 2.46 4.1-2.392-4.289-2.462-4.1 2.395.001-.001Zm19.3 11.083 4.289 2.46 4.1-2.395-4.288-2.459-4.1 2.393-.001.001Zm-14.472-8.312 4.289 2.461 4.1-2.395-4.289-2.459-4.1 2.392v.001Zm19.3 11.082 4.289 2.465 4.093-2.4-4.285-2.462-4.1 2.393.003.004Zm18.446-5.77-4.286-2.463-4.1 2.393 4.294 2.461 4.091-2.391h.001Zm-13.621 8.538 4.291 2.466 4.093-2.395-4.286-2.462-4.1 2.391h.002Zm-6.811-20.275-4.293-2.466-4.093 2.395 4.288 2.461 4.1-2.39h-.002Zm-12.5 9.183 4.286 2.465 4.1-2.393-4.285-2.465-4.1 2.393h-.001Zm4.825 2.771 4.286 2.463 4.1-2.393-4.286-2.463-4.1 2.393Zm1.879-9.478-4.289-2.461-4.1 2.392 4.287 2.462 4.1-2.393h.002Zm31.316 12.185-4.286-2.463-4.1 2.395 4.285 2.461 4.1-2.392.001-.001Zm-17.448 7.408-4.29-2.462-4.092 2.393 4.287 2.463 4.1-2.392-.005-.002Zm-8.4-16.445-4.1 2.393 4.286 2.462 4.1-2.393-4.288-2.462h.002Zm-1.352 10.84-4.285-2.461-4.1 2.393 4.285 2.461 4.1-2.393Zm14.58 8.374-4.287-2.463-4.1 2.393 4.288 2.462 4.1-2.392h-.001Zm-7.794-21.908-4.291-2.462-4.093 2.393 4.286 2.461 4.1-2.392h-.002Zm-21.544-12.372-4.1 2.393 4.288 2.461 4.094-2.391-4.285-2.463h.003Zm31.753 18.24-4.286-2.463-4.1 2.393 4.291 2.461 4.093-2.391h.002Zm-26.595 2.156-4.289-2.461-4.1 2.391 4.288 2.462 4.1-2.392h.001Z"
            fill="#4361EE"
        />
        <path
            d="m886.55 315.075-4.094 2.39-4.289-2.46 4.1-2.394 4.283 2.464ZM892.907 324.53l-4.1 2.393-4.286-2.461 4.099-2.393 4.287 2.461ZM914.018 330.851l-4.094 2.392-4.29-2.462 4.1-2.393 4.284 2.463ZM907.547 332.94l-4.094 2.4-4.29-2.466 4.1-2.39 4.284 2.456ZM912.429 335.744l-4.1 2.393-4.29-2.462 4.1-2.393 4.29 2.462ZM897.955 344.889l-4.1 2.393-18.838-10.82 4.091-2.393 18.847 10.82ZM914.354 354.312l-4.094 2.392-8.841-5.079 4.093-2.394 8.842 5.081Z"
            fill="#F8F9FC"
        />
        <path
            d="m942.188 297.863-53.833-31.081a1.872 1.872 0 0 0-1.889-.182l-2.656 1.542a1.875 1.875 0 0 1 1.892.183l2.8 1.618a.684.684 0 0 0-.215.082c-.472.272-1.033.6-1.58.918-.357.208-.717.414-1.075.625a1.112 1.112 0 0 0-.466 1.024l-.095 32.792a3.5 3.5 0 0 0 1.588 2.751c.421-.242.837-.486 1.256-.73l-1.256.73 51.69 29.844a1.126 1.126 0 0 0 1.138.107l2.6-1.513-.009 3.235a1.866 1.866 0 0 1-.78 1.7c.441-.256.884-.514 1.326-.769.442-.255.885-.514 1.326-.773a1.866 1.866 0 0 0 .779-1.7l.1-35.815a5.867 5.867 0 0 0-2.641-4.588Z"
            fill="#331083"
        />
        <path
            d="m938.45 301.518-51.689-29.844c-.88-.507-1.6-.091-1.6.916l-.095 32.792a3.515 3.515 0 0 0 1.588 2.751l51.69 29.844c.877.506 1.6.1 1.6-.909l.093-32.795a3.515 3.515 0 0 0-1.587-2.755Z"
            fill="#E8ECEF"
        />
        <path
            d="m939.534 299.407-53.832-31.081c-1.465-.846-2.663-.161-2.668 1.518l-.1 35.814a5.858 5.858 0 0 0 2.648 4.6l53.833 31.078c1.463.843 2.663.155 2.669-1.526l.1-35.813a5.857 5.857 0 0 0-2.65-4.59Zm.419 37.662c.017.313-.082.621-.277.865a1.018 1.018 0 0 1-1.326.044l-36.332-20.977-15.358-8.865c-.02-.01-.039-.026-.058-.037a2.369 2.369 0 0 1-.17-.119 2.434 2.434 0 0 1-.243-.2 3.402 3.402 0 0 1-.417-.472 3.456 3.456 0 0 1-.236-.362 3.226 3.226 0 0 1-.463-1.562l.095-32.792c0-.064 0-.125.008-.183a1.409 1.409 0 0 1 .118-.456.934.934 0 0 1 .172-.251c.023-.023.044-.046.069-.067.025-.021.032-.024.049-.036a.808.808 0 0 1 .355-.133 1.102 1.102 0 0 1 .506.062l.078.029c.083.034.164.074.242.119l51.69 29.844a3.54 3.54 0 0 1 1.592 2.755l-.094 32.794Z"
            fill="#3F37C9"
        />
        <path
            d="M908.116 303.634a1.423 1.423 0 0 0-.683-.26 1.425 1.425 0 0 0-.723.117c-.777.443-.781 1.888-.009 3.226a4.027 4.027 0 0 0 1.4 1.478 1.413 1.413 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.032 4.032 0 0 0-1.399-1.478Z"
            fill="#F72585"
        />
        <path
            d="M903.48 301.362a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM898.978 298.873a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM921.978 312.873a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM918.48 310.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM908.116 297.634a1.423 1.423 0 0 0-.683-.26 1.425 1.425 0 0 0-.723.117c-.777.443-.781 1.888-.009 3.226a4.027 4.027 0 0 0 1.4 1.478 1.413 1.413 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.032 4.032 0 0 0-1.399-1.478ZM903.48 295.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM898.978 292.609a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM921.978 306.609a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM913.478 290.767a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM913.478 318.767a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM908.478 287.767a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM908.478 315.767a.603.603 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.608.608 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.719 1.719 0 0 0-.6-.633ZM903.48 289.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM918.48 304.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM908.48 292.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM918.48 298.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM908.48 310.546a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM903.48 308.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM918.48 316.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM913.116 306.634a1.423 1.423 0 0 0-.683-.26 1.425 1.425 0 0 0-.723.117c-.777.443-.781 1.888-.009 3.226a4.027 4.027 0 0 0 1.4 1.478 1.413 1.413 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.032 4.032 0 0 0-1.399-1.478Z"
            fill="#7209B7"
        />
        <path
            d="M913.116 300.634a1.423 1.423 0 0 0-.683-.26 1.425 1.425 0 0 0-.723.117c-.777.443-.781 1.888-.009 3.226a4.027 4.027 0 0 0 1.4 1.478 1.413 1.413 0 0 0 1.405.143c.777-.443.782-1.888.009-3.226a4.032 4.032 0 0 0-1.399-1.478Z"
            fill="#F72585"
        />
        <path
            d="M913.48 295.099a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005ZM913.48 313.546a.965.965 0 0 0-.956-.1c-.529.3-.531 1.284-.006 2.194.227.411.555.757.953 1.005a.96.96 0 0 0 .956.1c.529-.3.532-1.284.006-2.194a2.735 2.735 0 0 0-.953-1.005Z"
            fill="#7209B7"
        />
        <path
            d="m945.427 333.408 1.915-1.113-2.242-3.883-1.915 1.113 2.242 3.883Z"
            fill="#D7E7F7"
        />
        <path
            d="M943.185 329.528a4.664 4.664 0 0 1-2.39 1.362l2.242 3.883 2.391-1.362-2.243-3.883Z"
            fill="#F8F9FC"
        />
        <path
            d="m946.569 332.76-1.143.651-2.39 1.362-1.143.651 8.213 14.219 4.67-2.668-8.207-14.215Z"
            fill="#F72585"
        />
        <path
            d="m954.771 346.972 1.915-1.113-8.207-14.216-1.915 1.113 8.207 14.216ZM942.137 330.367l1.915-1.113a4.681 4.681 0 0 0 1.053-.838c2.6-2.77 2.258-8.894-1.048-14.615a22.857 22.857 0 0 0-2.091-3.037l-1.919 1.112c.778.955 1.477 1.97 2.091 3.037 3.306 5.721 3.652 11.844 1.047 14.615-.308.33-.662.612-1.052.838l.004.001Z"
            fill="#B5179E"
        />
        <path
            d="m940.047 311.877 1.915-1.113a17.382 17.382 0 0 0-4.633-4.059 9.997 9.997 0 0 0-2.907-1.158l-1.915 1.113c1.023.231 2.004.622 2.906 1.158a17.401 17.401 0 0 1 4.634 4.059ZM932.505 306.66l1.915-1.113a5.372 5.372 0 0 0-3.836.479l-1.915 1.114a5.367 5.367 0 0 1 3.836-.48Z"
            fill="#B5179E"
        />
        <path
            d="M935.412 307.818a19.353 19.353 0 0 1 6.725 7.1c3.306 5.721 3.652 11.844 1.047 14.615a4.664 4.664 0 0 1-2.39 1.362 7.741 7.741 0 0 1-5.444-1.18 19.354 19.354 0 0 1-6.725-7.1c-3.706-6.419-3.686-13.349.044-15.474 1.867-1.068 4.307-.731 6.743.677Zm-5.179 13.88a14.718 14.718 0 0 0 5.125 5.4c1.857 1.073 3.717 1.331 5.138.522 2.843-1.62 2.858-6.9.034-11.794a14.765 14.765 0 0 0-5.125-5.4c-1.857-1.073-3.717-1.332-5.139-.522-2.842 1.62-2.857 6.9-.033 11.794Z"
            fill="#F72585"
        />
        <path
            d="M935.406 310.426c-1.857-1.073-3.717-1.332-5.139-.522-2.842 1.62-2.857 6.9-.033 11.794a14.734 14.734 0 0 0 5.125 5.4c1.857 1.073 3.717 1.331 5.138.522 2.843-1.62 2.858-6.9.034-11.794a14.75 14.75 0 0 0-5.125-5.4Z"
            fill="#4CC9F0"
        />
        <defs>
            <radialGradient
                id="a"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="matrix(84.75 146.7913 -568.13778 328.0145 652.888 474.806)"
            >
                <stop stopColor="#212739" />
                <stop offset={1} stopColor="#191822" />
            </radialGradient>
        </defs>
    </svg>
)

export default SvgComponent
